
export const fiveIndustryMap = {
  "9026c7ebeda04816ad90fd624d032c92":
    {
      name: "新制造", nameEn: 'New Manufacturing', shortName: '新制造', ico: 'manufacturing-icon.png',
      img: 'manufacturing-img.jpg', contentIco: 'manufacturing-icon.png', desc: '数字化驱动智能制造', index: '1',
      text: '通过物联网技术采集数据并通过人工智能算法处理数据的智能化制造，通过形成高度灵活、个性化、网络化的生产链条以实现传统制造业的产业升级。'
    },
  "f36984ecb26c49fa93910e90f3f7e448":
    {
      name: "新医疗", nameEn: 'New Medical Treatment', shortName: '新医疗', ico: 'treatment_icon.png', img: 'treatment.jpg',
      contentIco:'treatment_icon.png', desc: '创新药与智能器械的盛宴',index:'2',
      text: '新医疗是指新兴智能医学，是传统医学与人工智能、大数据、智能机器等技术的融合。'
    },
  "a179bcdf527e48b99c1cd7694820fe38":
    {
      name: "新一代信息技术", nameEn: 'New Information & Technology', shortName: '新技术', ico: 'technology_icon.png', img: 'technology.jpg',
      contentIco:'technology_icon.png', desc: '芯片、大数据、区块链、<br/>\n人工智能走向融合',index:'3',
      text: '新一代信息技术分为六个方面，分别是下一代通信网络、物联网、三网融合、新型平板显示、高性能集成电路和以云计算为代表的高端软件。'
    },
  "b43bfd8517c24e10b6672212e02a4656":
    {
      name: "新能源新材料", nameEn: 'New Energy & Materials', shortName: '新能源', ico: 'newenergy_icon.png', img: 'newenergy.jpg',
      contentIco:'newenergy_icon.png', desc: '技术突破带来的剧变想象',index:'4',
      text: '新能源新材料是指新近发展的或正在研发的、性能超群的一些材料，具有比传统材料更为优异的性能。'
    },
  "fab0b26a6c6c43c3a8544a629a2f358f":
    {
      name: "新消费新文娱", nameEn: 'New Consumption & Entertainment', shortName: '新消费', ico: 'consumer_icon.png', img: 'consumer.jpg',
      contentIco:'consumer_icon.png', desc: '全产业链变革时代来临',index:'5',
      text: '由数字技术等新技术、线上线下融合等新商业模式以及基于社交网络和新媒介的新消费关系所驱动之新消费行为。'
    }
};

export const area = [
  {
    "name": "美洲",
    "countries": [
      {
        "name": "阿根廷",
        "cont": "美洲",
        "count": 4,
        "website": "http://ar.mofcom.gov.cn/",
        "pdf": "阿根廷_agenting.pdf",
        "lvse": ""
      }, {
        "name": "安提瓜和巴布达",
        "cont": "美洲",
        "count": 0,
        "website": "http://ag.mofcom.gov.cn/",
        "pdf": "安提瓜和巴布达_antiguahebabuda.pdf",
        "lvse": ""
      }, {
        "name": "巴巴多斯",
        "cont": "美洲",
        "count": 0,
        "website": "http://bb.mofcom.gov.cn/",
        "pdf": "巴巴多斯_babaduosi.pdf",
        "lvse": ""
      }, {
        "name": "巴哈马",
        "cont": "美洲",
        "count": 0,
        "website": "http://bf.mofcom.gov.cn/",
        "pdf": "巴哈马_bahama.pdf",
        "lvse": ""
      }, {
        "name": "巴拉圭",
        "cont": "美洲",
        "count": 0,
        "website": "",
        "pdf": "巴拉圭_balagui.pdf",
        "lvse": ""
      }, {
        "name": "巴拿马",
        "cont": "美洲",
        "count": 0,
        "website": "http://panama.mofcom.gov.cn/",
        "pdf": "巴拿马_banama.pdf",
        "lvse": ""
      }, {
        "name": "巴西",
        "cont": "美洲",
        "count": 4,
        "website": "http://br.mofcom.gov.cn/",
        "pdf": "巴西_baxi.pdf",
        "lvse": "巴西_lvse-baxi.pdf"
      }, {
        "name": "北美洲其他国家（地区）",
        "cont": "美洲",
        "count": 0,
        "website": "",
        "pdf": "",
        "lvse": ""
      }, {
        "name": "玻利维亚",
        "cont": "美洲",
        "count": 0,
        "website": "http://bo.mofcom.gov.cn/",
        "pdf": "玻利维亚_boliweiya.pdf",
        "lvse": ""
      }, {
        "name": "伯利兹",
        "cont": "美洲",
        "count": 0,
        "website": "",
        "pdf": "",
        "lvse": ""
      }, {
        "name": "多米尼加",
        "cont": "美洲",
        "count": 0,
        "website": "",
        "pdf": "多米尼加_duominijia.pdf",
        "lvse": ""
      }, {
        "name": "多米尼克",
        "cont": "美洲",
        "count": 0,
        "website": "http://dm.mofcom.gov.cn/",
        "pdf": "多米尼克_duominike.pdf",
        "lvse": ""
      }, {
        "name": "厄瓜多尔",
        "cont": "美洲",
        "count": 0,
        "website": "http://ec.mofcom.gov.cn/",
        "pdf": "厄瓜多尔_eguaduoer.pdf",
        "lvse": ""
      }, {
        "name": "哥伦比亚",
        "cont": "美洲",
        "count": 0,
        "website": "http://co.mofcom.gov.cn/",
        "pdf": "哥伦比亚_gelunbiya.pdf",
        "lvse": ""
      }, {
        "name": "哥斯达黎加",
        "cont": "美洲",
        "count": 0,
        "website": "http://cr.mofcom.gov.cn/",
        "pdf": "哥斯达黎加_gesidalijia.pdf",
        "lvse": ""
      }, {
        "name": "格林纳达",
        "cont": "美洲",
        "count": 0,
        "website": "http://gd.mofcom.gov.cn/",
        "pdf": "格林纳达_gelinnada.pdf",
        "lvse": ""
      }, {
        "name": "古巴",
        "cont": "美洲",
        "count": 0,
        "website": "http://cu.mofcom.gov.cn/",
        "pdf": "古巴_guba.pdf",
        "lvse": ""
      }, {
        "name": "圭亚那",
        "cont": "美洲",
        "count": 0,
        "website": "http://gy.mofcom.gov.cn/",
        "pdf": "圭亚那_guiyana.pdf",
        "lvse": ""
      }, {"name": "海地", "cont": "美洲", "count": 0, "website": "", "pdf": "", "lvse": ""}, {
        "name": "洪都拉斯",
        "cont": "美洲",
        "count": 0,
        "website": "",
        "pdf": "洪都拉斯_hongdulasi.pdf",
        "lvse": ""
      }, {
        "name": "加拿大",
        "cont": "美洲",
        "count": 4,
        "website": "http://ca.mofcom.gov.cn/",
        "pdf": "加拿大_jianada.pdf",
        "lvse": ""
      }, {
        "name": "美国",
        "cont": "美洲",
        "count": 4,
        "website": "http://us.mofcom.gov.cn/",
        "pdf": "美国_meiguo.pdf",
        "lvse": "美国_lvse-meiguo.pdf"
      }, {
        "name": "秘鲁",
        "cont": "美洲",
        "count": 0,
        "website": "http://pe.mofcom.gov.cn/",
        "pdf": "秘鲁_bilu.pdf",
        "lvse": ""
      }, {
        "name": "墨西哥",
        "cont": "美洲",
        "count": 4,
        "website": "http://mx.mofcom.gov.cn/",
        "pdf": "墨西哥_moxige.pdf",
        "lvse": "墨西哥_lvse-moxige.pdf"
      }, {
        "name": "南美洲其他国家（地区）",
        "cont": "美洲",
        "count": 0,
        "website": "",
        "pdf": "",
        "lvse": ""
      }, {
        "name": "尼加拉瓜",
        "cont": "美洲",
        "count": 0,
        "website": "",
        "pdf": "尼加拉瓜_nijialagua.pdf",
        "lvse": ""
      }, {
        "name": "萨尔瓦多",
        "cont": "美洲",
        "count": 0,
        "website": "",
        "pdf": "萨尔瓦多_saerwaduo.pdf",
        "lvse": ""
      }, {
        "name": "苏里南",
        "cont": "美洲",
        "count": 0,
        "website": "http://sr.mofcom.gov.cn/",
        "pdf": "苏里南_sulinan.pdf",
        "lvse": ""
      }, {
        "name": "特立尼达和多巴哥",
        "cont": "美洲",
        "count": 0,
        "website": "http://tt.mofcom.gov.cn/",
        "pdf": "特立尼达和多巴哥_telinidaheduobage.pdf",
        "lvse": ""
      }, {
        "name": "危地马拉",
        "cont": "美洲",
        "count": 0,
        "website": "",
        "pdf": "危地马拉_weidimala.pdf",
        "lvse": ""
      }, {
        "name": "委内瑞拉",
        "cont": "美洲",
        "count": 0,
        "website": "http://ve.mofcom.gov.cn/",
        "pdf": "委内瑞拉_weineiruila.pdf",
        "lvse": ""
      }, {
        "name": "乌拉圭",
        "cont": "美洲",
        "count": 0,
        "website": "http://uy.mofcom.gov.cn/",
        "pdf": "乌拉圭_wulagui.pdf",
        "lvse": ""
      }, {
        "name": "牙买加",
        "cont": "美洲",
        "count": 0,
        "website": "http://jm.mofcom.gov.cn/",
        "pdf": "牙买加_yamaijia.pdf",
        "lvse": ""
      }, {
        "name": "智利",
        "cont": "美洲",
        "count": 4,
        "website": "http://cl.mofcom.gov.cn/",
        "pdf": "智利_zhili.pdf",
        "lvse": ""
      }]
  }, {
    "name": "亚洲",
    "countries": [
      {
        "name": "阿富汗",
        "cont": "亚洲",
        "count": 0,
        "website": "http://af.mofcom.gov.cn/",
        "pdf": "阿富汗_afuhan.pdf",
        "lvse": ""
      }, {
        "name": "阿联酋",
        "cont": "亚洲",
        "count": 4,
        "website": "http://ae.mofcom.gov.cn/",
        "pdf": "阿拉伯联合酋长国_alianqiu.pdf",
        "lvse": ""
      }, {
        "name": "阿曼",
        "cont": "亚洲",
        "count": 0,
        "website": "http://om.mofcom.gov.cn/",
        "pdf": "阿曼_aman.pdf",
        "lvse": ""
      }, {
        "name": "阿塞拜疆",
        "cont": "亚洲",
        "count": 0,
        "website": "http://az.mofcom.gov.cn/",
        "pdf": "阿塞拜疆_asaibaijiang.pdf",
        "lvse": ""
      }, {
        "name": "巴基斯坦",
        "cont": "亚洲",
        "count": 0,
        "website": "http://pk.mofcom.gov.cn/",
        "pdf": "巴基斯坦_bajisitan.pdf",
        "lvse": ""
      }, {"name": "巴勒斯坦", "cont": "亚洲", "count": 0, "website": "", "pdf": "", "lvse": ""}, {
        "name": "巴林",
        "cont": "亚洲",
        "count": 0,
        "website": "http://bh.mofcom.gov.cn/",
        "pdf": "巴林_balin.pdf",
        "lvse": ""
      }, {"name": "朝鲜", "cont": "亚洲", "count": 0, "website": "", "pdf": "", "lvse": ""}, {
        "name": "东帝汶",
        "cont": "亚洲",
        "count": 0,
        "website": "http://easttimor.mofcom.gov.cn/",
        "pdf": "东帝汶_dongdiwen.pdf",
        "lvse": ""
      }, {
        "name": "东盟",
        "cont": "亚洲",
        "count": "",
        "website": "http://asean.mofcom.gov.cn/",
        "pdf": "东盟_dongmeng.pdf",
        "lvse": "东盟_lvse-dongmeng.pdf"
      }, {
        "name": "菲律宾",
        "cont": "亚洲",
        "count": 0,
        "website": "http://ph.mofcom.gov.cn/",
        "pdf": "菲律宾_feilvbin.pdf",
        "lvse": ""
      }, {
        "name": "格鲁吉亚",
        "cont": "亚洲",
        "count": 0,
        "website": "http://ge.mofcom.gov.cn/",
        "pdf": "格鲁吉亚_gelujiya.pdf",
        "lvse": ""
      }, {
        "name": "哈萨克斯坦",
        "cont": "亚洲",
        "count": 4,
        "website": "http://kz.mofcom.gov.cn/",
        "pdf": "哈萨克斯坦_hasakesitan.pdf",
        "lvse": ""
      }, {
        "name": "韩国",
        "cont": "亚洲",
        "count": 4,
        "website": "http://kr.mofcom.gov.cn/",
        "pdf": "韩国_hanguo.pdf",
        "lvse": ""
      }, {
        "name": "吉尔吉斯斯坦",
        "cont": "亚洲",
        "count": 0,
        "website": "http://kg.mofcom.gov.cn/",
        "pdf": "吉尔吉斯斯坦_jierjisi.pdf",
        "lvse": ""
      }, {
        "name": "柬埔寨",
        "cont": "亚洲",
        "count": 4,
        "website": "http://cb.mofcom.gov.cn/",
        "pdf": "柬埔寨_jianpuzhai.pdf",
        "lvse": ""
      }, {
        "name": "卡塔尔",
        "cont": "亚洲",
        "count": 0,
        "website": "http://qa.mofcom.gov.cn/",
        "pdf": "卡塔尔_kataer.pdf",
        "lvse": ""
      }, {
        "name": "科威特",
        "cont": "亚洲",
        "count": 0,
        "website": "http://kw.mofcom.gov.cn/",
        "pdf": "科威特_keweite.pdf",
        "lvse": ""
      }, {
        "name": "老挝",
        "cont": "亚洲",
        "count": 0,
        "website": "http://la.mofcom.gov.cn/",
        "pdf": "老挝_laowo.pdf",
        "lvse": ""
      }, {
        "name": "黎巴嫩",
        "cont": "亚洲",
        "count": 0,
        "website": "http://lb.mofcom.gov.cn/",
        "pdf": "黎巴嫩_libanen.pdf",
        "lvse": ""
      }, {
        "name": "马尔代夫",
        "cont": "亚洲",
        "count": 0,
        "website": "",
        "pdf": "马尔代夫_maerdaifu.pdf",
        "lvse": ""
      }, {
        "name": "马来西亚",
        "cont": "亚洲",
        "count": 4,
        "website": "http://my.mofcom.gov.cn/",
        "pdf": "马来西亚_malaixiya.pdf",
        "lvse": ""
      }, {
        "name": "蒙古",
        "cont": "亚洲",
        "count": 0,
        "website": "http://mn.mofcom.gov.cn/",
        "pdf": "蒙古_mengguguo.pdf",
        "lvse": ""
      }, {
        "name": "孟加拉",
        "cont": "亚洲",
        "count": 0,
        "website": "http://bd.mofcom.gov.cn/",
        "pdf": "孟加拉国_mengjiala.pdf",
        "lvse": ""
      }, {
        "name": "缅甸",
        "cont": "亚洲",
        "count": 0,
        "website": "http://mm.mofcom.gov.cn/",
        "pdf": "缅甸_miandian.pdf",
        "lvse": ""
      }, {
        "name": "尼泊尔",
        "cont": "亚洲",
        "count": 0,
        "website": "http://np.mofcom.gov.cn/",
        "pdf": "尼泊尔_niboer.pdf",
        "lvse": ""
      }, {
        "name": "日本",
        "cont": "亚洲",
        "count": 0,
        "website": "http://jp.mofcom.gov.cn/",
        "pdf": "日本_riben.pdf",
        "lvse": "日本_lvse-riben.pdf"
      }, {
        "name": "沙特阿拉伯",
        "cont": "亚洲",
        "count": 0,
        "website": "http://sa.mofcom.gov.cn/",
        "pdf": "沙特阿拉伯_shatealabo.pdf",
        "lvse": ""
      }, {
        "name": "斯里兰卡",
        "cont": "亚洲",
        "count": 0,
        "website": "http://lk.mofcom.gov.cn/",
        "pdf": "斯里兰卡_sililanka.pdf",
        "lvse": ""
      }, {
        "name": "塔吉克斯坦",
        "cont": "亚洲",
        "count": 0,
        "website": "http://tj.mofcom.gov.cn/",
        "pdf": "塔吉克斯坦_tajikesitan.pdf",
        "lvse": ""
      }, {
        "name": "泰国",
        "cont": "亚洲",
        "count": 0,
        "website": "http://th.mofcom.gov.cn/",
        "pdf": "泰国_taiguo.pdf",
        "lvse": ""
      }, {
        "name": "土耳其",
        "cont": "亚洲",
        "count": 0,
        "website": "http://tr.mofcom.gov.cn/",
        "pdf": "土耳其_tuerqi.pdf",
        "lvse": ""
      }, {
        "name": "土库曼斯坦",
        "cont": "亚洲",
        "count": 0,
        "website": "http://tm.mofcom.gov.cn/",
        "pdf": "土库曼斯坦_tukumansitan.pdf",
        "lvse": ""
      }, {
        "name": "文莱",
        "cont": "亚洲",
        "count": 0,
        "website": "http://bn.mofcom.gov.cn/",
        "pdf": "文莱_wenlai.pdf",
        "lvse": ""
      }, {
        "name": "乌兹别克斯坦",
        "cont": "亚洲",
        "count": 0,
        "website": "http://uz.mofcom.gov.cn/",
        "pdf": "乌兹别克斯坦_wuzibieke.pdf",
        "lvse": ""
      }, {
        "name": "新加坡",
        "cont": "亚洲",
        "count": 4,
        "website": "http://sg.mofcom.gov.cn/",
        "pdf": "新加坡_xinjiapo.pdf",
        "lvse": "新加坡_lvse-xinjiapo.pdf"
      }, {
        "name": "叙利亚",
        "cont": "亚洲",
        "count": 0,
        "website": "http://sy.mofcom.gov.cn/",
        "pdf": "叙利亚_xuliya.pdf",
        "lvse": ""
      }, {
        "name": "亚美尼亚",
        "cont": "亚洲",
        "count": 0,
        "website": "http://am.mofcom.gov.cn/",
        "pdf": "亚美尼亚_yameiniya.pdf",
        "lvse": ""
      }, {
        "name": "亚洲其他国家（地区）",
        "cont": "亚洲",
        "count": 0,
        "website": "",
        "pdf": "",
        "lvse": ""
      }, {
        "name": "也门",
        "cont": "亚洲",
        "count": 0,
        "website": "http://ye.mofcom.gov.cn/",
        "pdf": "也门_yemen.pdf",
        "lvse": ""
      }, {
        "name": "伊拉克",
        "cont": "亚洲",
        "count": 0,
        "website": "http://iq.mofcom.gov.cn/",
        "pdf": "伊拉克_yilake.pdf",
        "lvse": ""
      }, {
        "name": "伊朗",
        "cont": "亚洲",
        "count": 0,
        "website": "http://ir.mofcom.gov.cn/",
        "pdf": "伊朗_yilang.pdf",
        "lvse": ""
      }, {
        "name": "以色列",
        "cont": "亚洲",
        "count": 4,
        "website": "http://il.mofcom.gov.cn/",
        "pdf": "以色列_yiselie.pdf",
        "lvse": ""
      }, {
        "name": "印度",
        "cont": "亚洲",
        "count": 0,
        "website": "http://in.mofcom.gov.cn/",
        "pdf": "印度_yindu.pdf",
        "lvse": ""
      }, {
        "name": "印度尼西亚",
        "cont": "亚洲",
        "count": 4,
        "website": "http://id.mofcom.gov.cn/",
        "pdf": "印度尼西亚_yindunixiya.pdf",
        "lvse": "印度尼西亚_lvse-yindunixiya.pdf"
      }, {
        "name": "约旦",
        "cont": "亚洲",
        "count": 0,
        "website": "http://jo.mofcom.gov.cn/",
        "pdf": "约旦_yuedan.pdf",
        "lvse": ""
      }, {
        "name": "越南",
        "cont": "亚洲",
        "count": 4,
        "website": "http://vn.mofcom.gov.cn/",
        "pdf": "越南_yuenan.pdf",
        "lvse": ""
      }, {"name": "中国", "cont": "亚洲", "count": 0, "website": "", "pdf": "", "lvse": ""}, {
        "name": "中国澳门",
        "cont": "亚洲",
        "count": 0,
        "website": "http://mo.mofcom.gov.cn/",
        "pdf": "中国澳门_zhongguoaomen.pdf",
        "lvse": ""
      }, {
        "name": "中国台湾",
        "cont": "亚洲",
        "count": 0,
        "website": "",
        "pdf": "中国台湾_zhongguotaiwan.pdf",
        "lvse": ""
      }, {
        "name": "中国香港",
        "cont": "亚洲",
        "count": 0,
        "website": "http://hk.mofcom.gov.cn/",
        "pdf": "中国香港_zhongguoxianggang.pdf",
        "lvse": ""
      }]
  }, {
    "name": "欧洲",
    "countries": [
      {
        "name": "阿尔巴尼亚",
        "cont": "欧洲",
        "count": 0,
        "website": "http://al.mofcom.gov.cn/",
        "pdf": "阿尔巴尼亚_aerbaniya.pdf",
        "lvse": "阿根廷_lvse-agenting.pdf"
      }, {
        "name": "爱尔兰",
        "cont": "欧洲",
        "count": 0,
        "website": "http://ie.mofcom.gov.cn/",
        "pdf": "爱尔兰_aierlan.pdf",
        "lvse": ""
      }, {
        "name": "爱沙尼亚",
        "cont": "欧洲",
        "count": 0,
        "website": "http://ee.mofcom.gov.cn/",
        "pdf": "爱沙尼亚_aishaniya.pdf",
        "lvse": ""
      }, {
        "name": "奥地利",
        "cont": "欧洲",
        "count": 4,
        "website": "http://at.mofcom.gov.cn/",
        "pdf": "奥地利_aodili.pdf",
        "lvse": ""
      }, {
        "name": "白俄罗斯",
        "cont": "欧洲",
        "count": 4,
        "website": "http://by.mofcom.gov.cn/",
        "pdf": "白俄罗斯_baieluosi.pdf",
        "lvse": ""
      }, {
        "name": "保加利亚",
        "cont": "欧洲",
        "count": 0,
        "website": "http://bg.mofcom.gov.cn/",
        "pdf": "保加利亚_baojialiya.pdf",
        "lvse": ""
      }, {
        "name": "北马其顿",
        "cont": "欧洲",
        "count": 0,
        "website": "http://mk.mofcom.gov.cn/",
        "pdf": "北马其顿_beimaqidun.pdf",
        "lvse": ""
      }, {
        "name": "比利时",
        "cont": "欧洲",
        "count": 0,
        "website": "http://be.mofcom.gov.cn/",
        "pdf": "比利时_bilishi.pdf",
        "lvse": ""
      }, {
        "name": "冰岛",
        "cont": "欧洲",
        "count": 0,
        "website": "http://is.mofcom.gov.cn/",
        "pdf": "冰岛_bingdao.pdf",
        "lvse": ""
      }, {
        "name": "波黑",
        "cont": "欧洲",
        "count": 0,
        "website": "http://ba.mofcom.gov.cn/",
        "pdf": "波黑_bohei.pdf",
        "lvse": ""
      }, {
        "name": "波兰",
        "cont": "欧洲",
        "count": 0,
        "website": "http://pl.mofcom.gov.cn/",
        "pdf": "波兰_bolan.pdf",
        "lvse": ""
      }, {
        "name": "丹麦",
        "cont": "欧洲",
        "count": 0,
        "website": "http://dk.mofcom.gov.cn/",
        "pdf": "丹麦_danmai.pdf",
        "lvse": ""
      }, {
        "name": "德国",
        "cont": "欧洲",
        "count": 4,
        "website": "http://de.mofcom.gov.cn/",
        "pdf": "德国_deguo.pdf",
        "lvse": "德国_lvse-deguo.pdf"
      }, {
        "name": "俄罗斯",
        "cont": "欧洲",
        "count": 4,
        "website": "http://ru.mofcom.gov.cn/",
        "pdf": "俄罗斯_eluosi.pdf",
        "lvse": "俄罗斯_lvse-eluosi.pdf"
      }, {
        "name": "法国",
        "cont": "欧洲",
        "count": 4,
        "website": "http://fr.mofcom.gov.cn/",
        "pdf": "法国_faguo.pdf",
        "lvse": "法国_lvse-faguo.pdf"
      }, {
        "name": "芬兰",
        "cont": "欧洲",
        "count": 4,
        "website": "http://fi.mofcom.gov.cn/",
        "pdf": "芬兰_fenlan.pdf",
        "lvse": ""
      }, {
        "name": "荷兰",
        "cont": "欧洲",
        "count": 4,
        "website": "http://nl.mofcom.gov.cn/",
        "pdf": "荷兰_helan.pdf",
        "lvse": ""
      }, {
        "name": "黑山",
        "cont": "欧洲",
        "count": 4,
        "website": "http://me.mofcom.gov.cn/",
        "pdf": "黑山_heishan.pdf",
        "lvse": ""
      }, {
        "name": "捷克",
        "cont": "欧洲",
        "count": 0,
        "website": "http://cz.mofcom.gov.cn/",
        "pdf": "捷克_jieke.pdf",
        "lvse": ""
      }, {
        "name": "克罗地亚",
        "cont": "欧洲",
        "count": 0,
        "website": "http://hr.mofcom.gov.cn/",
        "pdf": "克罗地亚_keluodiya.pdf",
        "lvse": ""
      }, {
        "name": "拉脱维亚",
        "cont": "欧洲",
        "count": 0,
        "website": "http://lv.mofcom.gov.cn/",
        "pdf": "拉脱维亚_latuoweiya.pdf",
        "lvse": ""
      }, {
        "name": "立陶宛",
        "cont": "欧洲",
        "count": 0,
        "website": "http://lt.mofcom.gov.cn/",
        "pdf": "立陶宛_litaowan.pdf",
        "lvse": ""
      }, {
        "name": "卢森堡",
        "cont": "欧洲",
        "count": 0,
        "website": "http://be.mofcom.gov.cn/",
        "pdf": "卢森堡_lusenbao.pdf",
        "lvse": ""
      }, {
        "name": "罗马尼亚",
        "cont": "欧洲",
        "count": 0,
        "website": "http://ro.mofcom.gov.cn/",
        "pdf": "罗马尼亚_luomaniya.pdf",
        "lvse": ""
      }, {
        "name": "马耳他",
        "cont": "欧洲",
        "count": 0,
        "website": "http://mt.mofcom.gov.cn/",
        "pdf": "马耳他_maerta.pdf",
        "lvse": ""
      }, {
        "name": "摩尔多瓦",
        "cont": "欧洲",
        "count": 4,
        "website": "http://md.mofcom.gov.cn/",
        "pdf": "摩尔多瓦_moerduowa.pdf",
        "lvse": ""
      }, {"name": "摩纳哥", "cont": "欧洲", "count": 0, "website": "", "pdf": "", "lvse": ""}, {
        "name": "挪威",
        "cont": "欧洲",
        "count": 4,
        "website": "http://no.mofcom.gov.cn/",
        "pdf": "挪威_nuowei.pdf",
        "lvse": ""
      }, {
        "name": "欧盟",
        "cont": "欧洲",
        "count": "",
        "website": "http://eu.mofcom.gov.cn/",
        "pdf": "欧盟_oumeng.pdf",
        "lvse": "欧盟_lvse-oumeng.pdf"
      }, {
        "name": "欧洲其他国家（地区）",
        "cont": "欧洲",
        "count": 0,
        "website": "",
        "pdf": "",
        "lvse": ""
      }, {
        "name": "葡萄牙",
        "cont": "欧洲",
        "count": 0,
        "website": "http://pt.mofcom.gov.cn/",
        "pdf": "葡萄牙_putaoya.pdf",
        "lvse": ""
      }, {
        "name": "瑞典",
        "cont": "欧洲",
        "count": 4,
        "website": "http://se.mofcom.gov.cn/",
        "pdf": "瑞典_ruidian.pdf",
        "lvse": ""
      }, {
        "name": "瑞士",
        "cont": "欧洲",
        "count": 0,
        "website": "http://ch.mofcom.gov.cn/",
        "pdf": "瑞士_ruishi.pdf",
        "lvse": ""
      }, {
        "name": "塞尔维亚",
        "cont": "欧洲",
        "count": 0,
        "website": "http://rs.mofcom.gov.cn/",
        "pdf": "塞尔维亚_saierweiya.pdf",
        "lvse": ""
      }, {
        "name": "塞浦路斯",
        "cont": "欧洲",
        "count": 0,
        "website": "http://cy.mofcom.gov.cn/",
        "pdf": "塞浦路斯_saipulusi.pdf",
        "lvse": ""
      }, {
        "name": "斯洛伐克",
        "cont": "欧洲",
        "count": 0,
        "website": "http://sk.mofcom.gov.cn/",
        "pdf": "斯洛伐克_siluofake.pdf",
        "lvse": ""
      }, {
        "name": "斯洛文尼亚",
        "cont": "欧洲",
        "count": 0,
        "website": "http://si.mofcom.gov.cn/",
        "pdf": "斯洛文尼亚_siluowenniya.pdf",
        "lvse": ""
      }, {
        "name": "乌克兰",
        "cont": "欧洲",
        "count": 0,
        "website": "http://ua.mofcom.gov.cn/",
        "pdf": "乌克兰_wukelan.pdf",
        "lvse": ""
      }, {
        "name": "西班牙",
        "cont": "欧洲",
        "count": 0,
        "website": "http://es.mofcom.gov.cn/",
        "pdf": "西班牙_xibanya.pdf",
        "lvse": ""
      }, {
        "name": "希腊",
        "cont": "欧洲",
        "count": 0,
        "website": "http://gr.mofcom.gov.cn/",
        "pdf": "希腊_xila.pdf",
        "lvse": ""
      }, {
        "name": "匈牙利",
        "cont": "欧洲",
        "count": 0,
        "website": "http://hu.mofcom.gov.cn/",
        "pdf": "匈牙利_xiongyali.pdf",
        "lvse": ""
      }, {
        "name": "意大利",
        "cont": "欧洲",
        "count": 0,
        "website": "http://it.mofcom.gov.cn/",
        "pdf": "意大利_yidali.pdf",
        "lvse": "意大利_lvse-yidali.pdf"
      }, {
        "name": "英国",
        "cont": "欧洲",
        "count": 4,
        "website": "http://gb.mofcom.gov.cn/",
        "pdf": "英国_yingguo.pdf",
        "lvse": "英国_lvse-yingguo.pdf"
      }]
  }, {
    "name": "非洲",
    "countries": [
      {
        "name": "阿尔及利亚",
        "cont": "非洲",
        "count": 0,
        "website": "http://dz.mofcom.gov.cn/",
        "pdf": "阿尔及利亚_aerjiliya.pdf",
        "lvse": ""
      }, {
        "name": "埃及",
        "cont": "非洲",
        "count": 4,
        "website": "http://eg.mofcom.gov.cn/",
        "pdf": "埃及_aiji.pdf",
        "lvse": ""
      }, {
        "name": "埃塞俄比亚",
        "cont": "非洲",
        "count": 4,
        "website": "http://et.mofcom.gov.cn/",
        "pdf": "埃塞俄比亚_aisaiebiya.pdf",
        "lvse": ""
      }, {"name": "安哥拉", "cont": "非洲", "count": 0, "website": "", "pdf": "", "lvse": ""}, {
        "name": "贝宁",
        "cont": "非洲",
        "count": 0,
        "website": "http://bj.mofcom.gov.cn/",
        "pdf": "贝宁_beining.pdf",
        "lvse": ""
      }, {
        "name": "博茨瓦那",
        "cont": "非洲",
        "count": 0,
        "website": "http://bw.mofcom.gov.cn/",
        "pdf": "博茨瓦纳_bociwana.pdf",
        "lvse": ""
      }, {
        "name": "布基纳法索",
        "cont": "非洲",
        "count": 0,
        "website": "",
        "pdf": "布基纳法索_bujinafasuo.pdf",
        "lvse": ""
      }, {
        "name": "布隆迪",
        "cont": "非洲",
        "count": 0,
        "website": "http://bi.mofcom.gov.cn/",
        "pdf": "布隆迪_bulongdi.pdf",
        "lvse": ""
      }, {
        "name": "赤道几内亚",
        "cont": "非洲",
        "count": 0,
        "website": "http://gq.mofcom.gov.cn/",
        "pdf": "赤道几内亚_chidaojineiya.pdf",
        "lvse": ""
      }, {
        "name": "多哥",
        "cont": "非洲",
        "count": 0,
        "website": "http://tg.mofcom.gov.cn/",
        "pdf": "多哥_duoge.pdf",
        "lvse": ""
      }, {
        "name": "厄立特里亚",
        "cont": "非洲",
        "count": 0,
        "website": "http://er.mofcom.gov.cn/",
        "pdf": "厄立特里亚_eliteliya.pdf",
        "lvse": ""
      }, {
        "name": "非洲其他国家（地区）",
        "cont": "非洲",
        "count": 0,
        "website": "",
        "pdf": "",
        "lvse": ""
      }, {
        "name": "佛得角",
        "cont": "非洲",
        "count": 0,
        "website": "http://cv.mofcom.gov.cn/",
        "pdf": "佛得角_fodejiao.pdf",
        "lvse": ""
      }, {
        "name": "冈比亚",
        "cont": "非洲",
        "count": "",
        "website": "",
        "pdf": "冈比亚_gangbiya.pdf",
        "lvse": ""
      }, {
        "name": "刚果（布）",
        "cont": "非洲",
        "count": 0,
        "website": "http://cg.mofcom.gov.cn/",
        "pdf": "刚果（布）_gangguobu.pdf",
        "lvse": ""
      }, {
        "name": "刚果（金）",
        "cont": "非洲",
        "count": 0,
        "website": "http://cd.mofcom.gov.cn/",
        "pdf": "刚果（金）_gangguojin.pdf",
        "lvse": ""
      }, {
        "name": "吉布提",
        "cont": "非洲",
        "count": 0,
        "website": "http://dj.mofcom.gov.cn/",
        "pdf": "吉布提_jibuti.pdf",
        "lvse": ""
      }, {
        "name": "几内亚",
        "cont": "非洲",
        "count": 0,
        "website": "http://gn.mofcom.gov.cn/",
        "pdf": "几内亚_jineiya.pdf",
        "lvse": ""
      }, {
        "name": "几内亚比绍",
        "cont": "非洲",
        "count": 0,
        "website": "http://gw.mofcom.gov.cn/",
        "pdf": "几内亚比绍_jineiyabishao.pdf",
        "lvse": ""
      }, {
        "name": "加纳",
        "cont": "非洲",
        "count": 0,
        "website": "http://gh.mofcom.gov.cn/",
        "pdf": "加纳_jiana.pdf",
        "lvse": ""
      }, {
        "name": "加蓬",
        "cont": "非洲",
        "count": 0,
        "website": "http://ga.mofcom.gov.cn/",
        "pdf": "加蓬_jiapeng.pdf",
        "lvse": ""
      }, {
        "name": "津巴布韦",
        "cont": "非洲",
        "count": 0,
        "website": "http://zimbabwe.mofcom.gov.cn/",
        "pdf": "津巴布韦_jinbabuwei.pdf",
        "lvse": ""
      }, {
        "name": "喀麦隆",
        "cont": "非洲",
        "count": 0,
        "website": "http://cm.mofcom.gov.cn/",
        "pdf": "喀麦隆_kamailong.pdf",
        "lvse": ""
      }, {
        "name": "科摩罗",
        "cont": "非洲",
        "count": 0,
        "website": "http://km.mofcom.gov.cn/",
        "pdf": "科摩罗_kemoluo.pdf",
        "lvse": ""
      }, {
        "name": "科特迪瓦",
        "cont": "非洲",
        "count": 0,
        "website": "http://ci.mofcom.gov.cn/",
        "pdf": "科特迪瓦_ketediwa.pdf",
        "lvse": ""
      }, {
        "name": "肯尼亚",
        "cont": "非洲",
        "count": 0,
        "website": "http://ke.mofcom.gov.cn/",
        "pdf": "肯尼亚_kenniya.pdf",
        "lvse": ""
      }, {
        "name": "莱索托",
        "cont": "非洲",
        "count": 0,
        "website": "http://ls.mofcom.gov.cn/",
        "pdf": "莱索托_laisuotuo.pdf",
        "lvse": ""
      }, {
        "name": "利比里亚",
        "cont": "非洲",
        "count": 0,
        "website": "http://lr.mofcom.gov.cn/",
        "pdf": "利比里亚_libiliya.pdf",
        "lvse": ""
      }, {
        "name": "利比亚",
        "cont": "非洲",
        "count": 0,
        "website": "http://ly.mofcom.gov.cn/",
        "pdf": "利比亚_libiya.pdf",
        "lvse": ""
      }, {
        "name": "卢旺达",
        "cont": "非洲",
        "count": 0,
        "website": "http://rw.mofcom.gov.cn/",
        "pdf": "卢旺达_luwangda.pdf",
        "lvse": ""
      }, {
        "name": "马达加斯加",
        "cont": "非洲",
        "count": 0,
        "website": "http://mg.mofcom.gov.cn/",
        "pdf": "马达加斯加_madajiasijia.pdf",
        "lvse": ""
      }, {
        "name": "马拉维",
        "cont": "非洲",
        "count": 0,
        "website": "http://malawi.mofcom.gov.cn/",
        "pdf": "马拉维_malawei.pdf",
        "lvse": ""
      }, {
        "name": "马里",
        "cont": "非洲",
        "count": 0,
        "website": "http://ml.mofcom.gov.cn/",
        "pdf": "马里_mali.pdf",
        "lvse": ""
      }, {
        "name": "毛里求斯",
        "cont": "非洲",
        "count": 0,
        "website": "http://mu.mofcom.gov.cn/",
        "pdf": "毛里求斯_maoliqiusi.pdf",
        "lvse": ""
      }, {
        "name": "毛里塔尼亚",
        "cont": "非洲",
        "count": 0,
        "website": "http://mr.mofcom.gov.cn/",
        "pdf": "毛里塔尼亚_maolitaniya.pdf",
        "lvse": ""
      }, {
        "name": "摩洛哥",
        "cont": "非洲",
        "count": 0,
        "website": "http://ma.mofcom.gov.cn/",
        "pdf": "摩洛哥_moluoge.pdf",
        "lvse": ""
      }, {
        "name": "莫桑比克",
        "cont": "非洲",
        "count": 0,
        "website": "http://mz.mofcom.gov.cn/",
        "pdf": "莫桑比克_mosangbike.pdf",
        "lvse": ""
      }, {
        "name": "纳米比亚",
        "cont": "非洲",
        "count": 4,
        "website": "http://na.mofcom.gov.cn/",
        "pdf": "纳米比亚_namibiya.pdf",
        "lvse": ""
      }, {
        "name": "南非",
        "cont": "非洲",
        "count": 4,
        "website": "http://za.mofcom.gov.cn/",
        "pdf": "南非_nanfei.pdf",
        "lvse": "南非_lvse-nanfei.pdf"
      }, {
        "name": "南苏丹",
        "cont": "非洲",
        "count": 0,
        "website": "http://nsd.mofcom.gov.cn/",
        "pdf": "南苏丹_nansudan.pdf",
        "lvse": ""
      }, {
        "name": "尼日尔",
        "cont": "非洲",
        "count": 0,
        "website": "http://ne.mofcom.gov.cn/",
        "pdf": "尼日尔_nirier.pdf",
        "lvse": ""
      }, {
        "name": "尼日利亚",
        "cont": "非洲",
        "count": 0,
        "website": "http://nigeria.mofcom.gov.cn/",
        "pdf": "尼日利亚_niriliya.pdf",
        "lvse": ""
      }, {
        "name": "塞拉利昂",
        "cont": "非洲",
        "count": 0,
        "website": "http://sl.mofcom.gov.cn/",
        "pdf": "塞拉利昂_sailaliang.pdf",
        "lvse": ""
      }, {
        "name": "塞内加尔",
        "cont": "非洲",
        "count": 0,
        "website": "http://senegal.mofcom.gov.cn/",
        "pdf": "塞内加尔_saineijiaer.pdf",
        "lvse": ""
      }, {
        "name": "塞舌尔",
        "cont": "非洲",
        "count": 0,
        "website": "http://sc.mofcom.gov.cn/",
        "pdf": "塞舌尔_saisheer.pdf",
        "lvse": ""
      }, {
        "name": "苏丹",
        "cont": "非洲",
        "count": 0,
        "website": "http://sd.mofcom.gov.cn/",
        "pdf": "苏丹_sudan.pdf",
        "lvse": ""
      }, {
        "name": "索马里",
        "cont": "非洲",
        "count": 0,
        "website": "",
        "pdf": "",
        "lvse": ""
      }, {
        "name": "坦桑尼亚",
        "cont": "非洲",
        "count": 4,
        "website": "http://tz.mofcom.gov.cn/",
        "pdf": "坦桑尼亚_tansangniya.pdf",
        "lvse": ""
      }, {"name": "突尼斯", "cont": "非洲", "count": 0, "website": "", "pdf": "", "lvse": ""}, {
        "name": "乌干达",
        "cont": "非洲",
        "count": 0,
        "website": "http://ug.mofcom.gov.cn/",
        "pdf": "乌干达_wuganda.pdf",
        "lvse": ""
      }, {
        "name": "赞比亚",
        "cont": "非洲",
        "count": 4,
        "website": "http://zm.mofcom.gov.cn/",
        "pdf": "赞比亚_zanbiya.pdf",
        "lvse": ""
      }, {
        "name": "乍得",
        "cont": "非洲",
        "count": 0,
        "website": "http://tchad.mofcom.gov.cn/",
        "pdf": "乍得_zhade.pdf",
        "lvse": ""
      }, {
        "name": "中非",
        "cont": "非洲",
        "count": 0,
        "website": "http://cf.mofcom.gov.cn/",
        "pdf": "中非共和国_zhongfei.pdf",
        "lvse": ""
      }]
  }, {
    "name": "大洋洲",
    "countries": [
      {
        "name": "澳大利亚",
        "cont": "大洋洲",
        "count": 4,
        "website": "http://au.mofcom.gov.cn/",
        "pdf": "澳大利亚_aodaliya.pdf",
        "lvse": "澳大利亚_lvse-aodaliya.pdf"
      }, {
        "name": "巴布亚新几内亚",
        "cont": "大洋洲",
        "count": 4,
        "website": "http://pg.mofcom.gov.cn/",
        "pdf": "巴布亚新几内亚_babuyaxinjineiya.pdf",
        "lvse": ""
      }, {
        "name": "斐济",
        "cont": "大洋洲",
        "count": 0,
        "website": "http://fj.mofcom.gov.cn/",
        "pdf": "斐济_feiji.pdf",
        "lvse": ""
      }, {
        "name": "基里巴斯",
        "cont": "大洋洲",
        "count": 0,
        "website": "",
        "pdf": "基里巴斯_jilibasi.pdf",
        "lvse": ""
      }, {
        "name": "密克罗尼西亚",
        "cont": "大洋洲",
        "count": 0,
        "website": "http://fm.mofcom.gov.cn/",
        "pdf": "密克罗尼西亚_mikeluonixiya.pdf",
        "lvse": ""
      }, {
        "name": "萨摩亚",
        "cont": "大洋洲",
        "count": 0,
        "website": "",
        "pdf": "萨摩亚_samoya.pdf",
        "lvse": ""
      }, {
        "name": "所罗门群岛",
        "cont": "大洋洲",
        "count": 0,
        "website": "",
        "pdf": "所罗门群岛_suoluomenqundao.pdf",
        "lvse": ""
      }, {
        "name": "汤加",
        "cont": "大洋洲",
        "count": 0,
        "website": "http://to.mofcom.gov.cn/",
        "pdf": "汤加_tangjia.pdf",
        "lvse": ""
      }, {
        "name": "瓦努阿图",
        "cont": "大洋洲",
        "count": 0,
        "website": "http://vu.mofcom.gov.cn/",
        "pdf": "瓦努阿图_wanuatu.pdf",
        "lvse": ""
      }, {
        "name": "新西兰",
        "cont": "大洋洲",
        "count": 4,
        "website": "http://nz.mofcom.gov.cn/",
        "pdf": "新西兰_xinxilan.pdf",
        "lvse": ""
      }]
  }
];

export const areaMap = {}
for (const key in area) {
  const one = area[key];
  const countries = one.countries;
  const c = {}
  for (const countriesKey in countries) {
    const temp = countries[countriesKey];
    c[temp.name] = temp
  }
  areaMap[one.name] = {name:one.name,countries:c}
}

export const scheduleTypes =  {
  professional: [
    {name: '法律服务', nameEn: 'Law Service', type: '1', img: '19'},
    {name: '会计(审计)服务', nameEn: 'Audit Service', type: '2', img: '20'},
    {name: '商务咨询', nameEn: 'Commercial Consulting', type: '3', img: '21'},
    {name: '商标受理', nameEn: 'Trademark Acceptance', type: '4', img: '22'},
    {name: '专家咨询服务', nameEn: 'Consulting with Professionals', type: '5', img: '23'},
    {name: '税务服务', nameEn: 'Tax Service', type: '6', img: '24'},
  ],
  financial: [
    {name: '国际融资业务', nameEn: 'International Financing Service', type: '7', img: '26', ico: 'finance/01'},
    {name: '信保服务', nameEn: 'Credit Insurance Service', type: '8', img: '27', ico: 'finance/02'},
    {name: '国际结算业务', nameEn: 'International Settlement Business', type: '9', img: '28', ico: 'finance/03'},
    {name: '国外银行业务', nameEn: 'Foreign Bank Service', type: '10', img: '29', ico: 'finance/04'},
    {name: '信贷业务', nameEn: 'Credit Service', type: '11', img: '30', ico: 'finance/05'},
  ]
}

/**
 * 41 投资政策 :  http://essentra.slidea.cn/web/form/fdiSearch?keyword=&catalog=C1  公众号 走出去服务岗 -> 产业政策
 * 39 贸易资讯 :  https://www.investgo.cn/channel/v3_0/gb/index.shtml  投资参考
 * 48 投资资讯 :  http://fec.mofcom.gov.cn/article/tzhzcj/xgzx/  商务部  投资合作促进 -> 相关资讯
 * 42 风险预警 :  http://essentra.slidea.cn/web/form/fdiSearch?keyword=&catalog=C2  公众号 走出去服务岗 -> 境外安全
 * 49 <无> :  http://fec.mofcom.gov.cn/article/fwydyl/zgzx/  商务部  服务“一带一路” -> 相关资讯
 * @type {{"48": string, "39": string, "41": string, "42": string}}
 */
export const newsCategoryIdToName = {
  "48":"投资资讯",
  "49":"一带一路资讯",
  "41":"投资政策",
  "42":"风险预警",
}
export const newsCategoryIdToNameEn = {
  "48":"Investment Intelligence",
  "49":"B&R Intelligence",
  "41":"Investment Policy",
  "42":"Risk Warning",
}

export const newsCategoryIdArray=['48','49','41','42']

export const newsCategoryNameToId = {
}
for (const key in newsCategoryIdToName) {
  newsCategoryNameToId[newsCategoryIdToName[key]] = key
}

export const newsCategoryNameEnToId = {
}
for (const key in newsCategoryIdToNameEn) {
  newsCategoryNameEnToId[newsCategoryIdToNameEn[key]] = key
}

export const areaArray = [{"childrenJSON":[{"englishValue":"Afghanistan","pinyin":",AFH,EFH,","id":"3081","sort":"1040515","type":"qy","chineseValue":"阿富汗","isDel":"1","parentId":"3053","codeValue":"0.2"},{"englishValue":"Armenia","pinyin":",YMNYGHG,YMNYGHG,YMNYGHG,YMNYGHG,","id":"2968","sort":"1040212","type":"qy","chineseValue":"亚美尼亚共和国","isDel":"1","parentId":"2956","codeValue":"0.2"},{"englishValue":"Australia","pinyin":",ADLY,ADLY,","id":"3084","sort":"1040601","type":"qy","chineseValue":"澳大利亚","isDel":"1","parentId":"◎3083◎3502◎","codeValue":"1"},{"englishValue":"Azerbaijan","pinyin":",ASBJ,ESBJ,ASBJ,ESBJ,","id":"3082","sort":"1040516","type":"qy","chineseValue":"阿塞拜疆","isDel":"1","parentId":"3053","codeValue":"0.2"},{"englishValue":"Bahrain","pinyin":",BL,","id":"3057","sort":"1040504","type":"qy","chineseValue":"巴林","isDel":"1","parentId":"◎3053◎3215◎3235◎","codeValue":"0.2"},{"englishValue":"Bangladesh","pinyin":",MJLG,","id":"3009","sort":"1040305","type":"qy","chineseValue":"孟加拉国","isDel":"1","parentId":"3004","codeValue":"0.2"},{"englishValue":"Bhutan","pinyin":",BD,FD,","id":"3007","sort":"1040303","type":"qy","chineseValue":"不丹","isDel":"1","parentId":"3004","codeValue":"0.2"},{"englishValue":"Brunei","pinyin":",WL,","id":"2966","sort":"1040210","type":"qy","chineseValue":"文莱","isDel":"1","parentId":"◎2956◎3102◎3348◎","codeValue":"0.2"},{"englishValue":"Cambodia","pinyin":",JBZ,JPZ,","id":"2961","sort":"1040205","type":"qy","chineseValue":"柬埔寨","isDel":"1","parentId":"◎2956◎3102◎","codeValue":"0.2"},{"englishValue":"China","pinyin":",ZG,","id":"2920","sort":"1040000","type":"qy","chineseValue":"中国","isDel":"1","parentId":"2852","codeValue":"0.2"},{"englishValue":"Cook","pinyin":",KKQD,","id":"3095","sort":"1040604","type":"qy","chineseValue":"库克群岛","isDel":"1","parentId":"3083","codeValue":"0.2"},{"englishValue":"Fiji","pinyin":",FJ,","id":"3094","sort":"1040603","type":"qy","chineseValue":"斐济","isDel":"1","parentId":"3083","codeValue":"0.2"},{"englishValue":"Georgia","pinyin":",GLJY,","id":"2960","sort":"1040204","type":"qy","chineseValue":"格鲁吉亚","isDel":"1","parentId":"2956","codeValue":"0.2"},{"englishValue":"HongKong, China","pinyin":",XG,","id":"2946","sort":"1040105","type":"qy","chineseValue":"中国香港","isDel":"1","parentId":"2852","codeValue":"0.2"},{"englishValue":"India","pinyin":",YD,YD,","id":"3011","sort":"1040307","type":"qy","chineseValue":"印度","isDel":"1","parentId":"3004","codeValue":"0.8"},{"englishValue":"Indonesia","pinyin":",YDNXY,YDNXY,","id":"2969","sort":"1040213","type":"qy","chineseValue":"印度尼西亚","isDel":"1","parentId":"◎2956◎3102◎","codeValue":"0.2"},{"englishValue":"Iran","pinyin":",YL,","id":"3076","sort":"1040510","type":"qy","chineseValue":"伊朗","isDel":"1","parentId":"◎3053◎3235◎","codeValue":"0.2"},{"englishValue":"Iraq","pinyin":",YLK,","id":"3077","sort":"1040511","type":"qy","chineseValue":"伊拉克","isDel":"1","parentId":"◎3053◎3235◎","codeValue":"0.2"},{"englishValue":"Israel","pinyin":",YSL,YSL,","id":"3078","sort":"1040512","type":"qy","chineseValue":"以色列","isDel":"1","parentId":"◎3053◎3235◎","codeValue":"1"},{"englishValue":"Japan","pinyin":",RB,","id":"2872","sort":"1040103","type":"qy","chineseValue":"日本","isDel":"1","parentId":"◎2852◎3348◎","codeValue":"1"},{"englishValue":"Jordan","pinyin":",YD,YD,","id":"3079","sort":"1040513","type":"qy","chineseValue":"约旦","isDel":"1","parentId":"◎3053◎3235◎","codeValue":"0.2"},{"englishValue":"Kazakhstan","pinyin":",HSKST,KSKST,","id":"3049","sort":"1040402","type":"qy","chineseValue":"哈萨克斯坦","isDel":"1","parentId":"3047","codeValue":"0.2"},{"englishValue":"Kirgizstan","pinyin":",JEJSST,","id":"3051","sort":"1040404","type":"qy","chineseValue":"吉尔吉斯斯坦","isDel":"1","parentId":"3047","codeValue":"0.2"},{"englishValue":"Kuwait","pinyin":",KWT,","id":"3059","sort":"1040506","type":"qy","chineseValue":"科威特","isDel":"1","parentId":"◎3053◎3215◎3235◎","codeValue":"0.2"},{"englishValue":"Laos","pinyin":",LZ,LW,","id":"2962","sort":"1040206","type":"qy","chineseValue":"老挝","isDel":"1","parentId":"◎2956◎3102◎","codeValue":"0.2"},{"englishValue":"Lebanon","pinyin":",LBN,","id":"3060","sort":"1040507","type":"qy","chineseValue":"黎巴嫩","isDel":"1","parentId":"◎3053◎3235◎","codeValue":"0.2"},{"englishValue":"Malaysia","pinyin":",MLXY,","id":"2963","sort":"1040207","type":"qy","chineseValue":"马来西亚","isDel":"1","parentId":"◎2956◎3348◎3102◎","codeValue":"0.2"},{"englishValue":"Maldives","pinyin":",MEDF,","id":"3006","sort":"1040302","type":"qy","chineseValue":"马尔代夫","isDel":"1","parentId":"3004","codeValue":"0.2"},{"englishValue":"Marshall Islands","pinyin":",MSEQD,","id":"3521","sort":"1040611","type":"qy","chineseValue":"马绍尔群岛","isDel":"1","parentId":"3083","codeValue":"0.2"},{"englishValue":"Micronesia","pinyin":",MKLNXYLB,","id":"3097","sort":"1040606","type":"qy","chineseValue":"密克罗尼西亚联邦","isDel":"1","parentId":"3083","codeValue":"0.2"},{"englishValue":"Mongolia","pinyin":",MG,","id":"2955","sort":"1040105","type":"qy","chineseValue":"蒙古","isDel":"1","parentId":"2852","codeValue":"0.2"},{"englishValue":"Myanmar","pinyin":",MD,","id":"2964","sort":"1040208","type":"qy","chineseValue":"缅甸","isDel":"1","parentId":"◎2956◎3102◎","codeValue":"0.2"},{"englishValue":"Nepal","pinyin":",NBE,NPE,","id":"3010","sort":"1040306","type":"qy","chineseValue":"尼泊尔","isDel":"1","parentId":"3004","codeValue":"0.2"},{"englishValue":"New Zealand","pinyin":",XXL,","id":"3101","sort":"1040610","type":"qy","chineseValue":"新西兰","isDel":"1","parentId":"◎3083◎3502◎","codeValue":"0.8"},{"englishValue":"North Korea","pinyin":",CX,ZX,","id":"2853","sort":"1040101","type":"qy","chineseValue":"朝鲜","isDel":"1","parentId":"2852","codeValue":"0.2"},{"englishValue":"Oman","pinyin":",AM,EM,","id":"3055","sort":"1040502","type":"qy","chineseValue":"阿曼","isDel":"1","parentId":"◎3053◎3215◎3235◎","codeValue":"0.2"},{"englishValue":"Pakistan","pinyin":",BJST,","id":"3008","sort":"1040304","type":"qy","chineseValue":"巴基斯坦","isDel":"1","parentId":"3004","codeValue":"0.2"},{"englishValue":"Palau","pinyin":",PL,","id":"16890","sort":"1040612","type":"qy","chineseValue":"帕劳","isDel":"1","parentId":"3083","codeValue":"0.2"},{"englishValue":"Palestine","pinyin":",BLST,BLST,","id":"3056","sort":"1040503","type":"qy","chineseValue":"巴勒斯坦","isDel":"1","parentId":"◎3053◎3235◎","codeValue":"0.2"},{"englishValue":"Papua New Guinea","pinyin":",BBYXJNY,","id":"3093","sort":"1040602","type":"qy","chineseValue":"巴布亚新几内亚","isDel":"1","parentId":"3083","codeValue":"0.2"},{"englishValue":"Pauru","pinyin":",NL,","id":"3098","sort":"1040607","type":"qy","chineseValue":"瑙鲁","isDel":"1","parentId":"3083","codeValue":"0.2"},{"englishValue":"Philippines","pinyin":",FLB,","id":"2959","sort":"1040203","type":"qy","chineseValue":"菲律宾","isDel":"1","parentId":"◎2956◎3102◎","codeValue":"0.2"},{"englishValue":"Qatar","pinyin":",QDE,QTE,KDE,KTE,","id":"3058","sort":"1040505","type":"qy","chineseValue":"卡塔尔","isDel":"1","parentId":"◎3053◎3215◎3235◎","codeValue":"0.2"},{"englishValue":"Republic of Korea","pinyin":",HG,","id":"2854","sort":"1040102","type":"qy","chineseValue":"韩国","isDel":"1","parentId":"2852","codeValue":"0.8"},{"englishValue":"Samoa","pinyin":",MZSMY,MSSMY,MZSMY,MSSMY,","id":"3096","sort":"1040605","type":"qy","chineseValue":"美属萨摩亚","isDel":"1","parentId":"3083","codeValue":"0.2"},{"englishValue":"Saudi Arabia","pinyin":",STELB,STELB,STALB,STALB,STALB,STELB,","id":"3061","sort":"1040508","type":"qy","chineseValue":"沙特阿拉伯","isDel":"1","parentId":"◎3053◎3215◎3215◎","codeValue":"0.2"},{"englishValue":"Singapore","pinyin":",XJP,","id":"2967","sort":"1040211","type":"qy","chineseValue":"新加坡","isDel":"1","parentId":"◎2956◎3102◎3348◎","codeValue":"0.8"},{"englishValue":"Srilanka","pinyin":",SLLQ,SLLK,","id":"3005","sort":"1040301","type":"qy","chineseValue":"斯里兰卡","isDel":"1","parentId":"3004","codeValue":"0.2"},{"englishValue":"Syria","pinyin":",XLY,","id":"3080","sort":"1040514","type":"qy","chineseValue":"叙利亚","isDel":"1","parentId":"◎3053◎3235◎","codeValue":"0.2"},{"englishValue":"Taiwan, China","pinyin":",TW,","id":"2948","sort":"1040105","type":"qy","chineseValue":"中国台湾","isDel":"1","parentId":"2852","codeValue":"0.2"},{"englishValue":"Tajikistan","pinyin":",DJKST,TJKST,","id":"3050","sort":"1040403","type":"qy","chineseValue":"塔吉克斯坦","isDel":"1","parentId":"3047","codeValue":"0.2"},{"englishValue":"Thailand","pinyin":",TG,","id":"2965","sort":"1040209","type":"qy","chineseValue":"泰国","isDel":"1","parentId":"◎2956◎3102◎","codeValue":"0.2"},{"englishValue":"Timor","pinyin":",DDW,","id":"2958","sort":"1040202","type":"qy","chineseValue":"东帝汶","isDel":"1","parentId":"2956","codeValue":"0.2"},{"englishValue":"Tonga","pinyin":",SJ,TJ,","id":"3099","sort":"1040608","type":"qy","chineseValue":"汤加","isDel":"1","parentId":"3083","codeValue":"0.2"},{"englishValue":"Turkmenistan","pinyin":",TKMST,","id":"3048","sort":"1040401","type":"qy","chineseValue":"土库曼斯坦","isDel":"1","parentId":"3047","codeValue":"0.2"},{"englishValue":"United Arab Emirates","pinyin":",ALBLGQCG,ELBLHQZG,ELBLHQCG,ELBLHQZG,ALBLHQZG,ELBLGQCG,ALBLHQCG,ALBLGQZG,ALBLHQCG,ELBLGQZG,ALBLHQZG,ALBLGQCG,ELBLGQCG,ALBLHQCG,ALBLGQZG,ELBLHQCG,ELBLGQZG,ELBLGQZG,ELBLHQZG,ELBLHQCG,ALBLGQCG,ALBLHQZG,ELBLGQCG,ALBLGQZG,","id":"3054","sort":"1040501","type":"qy","chineseValue":"阿拉伯联合酋长国","isDel":"1","parentId":"◎3053◎3215◎3235◎","codeValue":"0.2"},{"englishValue":"Uzbekistan","pinyin":",WCBKST,WZBKST,","id":"3052","sort":"1040405","type":"qy","chineseValue":"乌兹别克斯坦","isDel":"1","parentId":"3047","codeValue":"0.2"},{"englishValue":"Vanuatu","pinyin":",WNET,WNAT,WNET,WNAT,","id":"3100","sort":"1040609","type":"qy","chineseValue":"瓦努阿图","isDel":"1","parentId":"3083","codeValue":"0.2"},{"englishValue":"Vietnam","pinyin":",YN,YN,","id":"2957","sort":"1040201","type":"qy","chineseValue":"越南","isDel":"1","parentId":"◎2956◎3102◎3348◎","codeValue":"0.2"},{"englishValue":"Yemen","pinyin":",YM,","id":"3075","sort":"1040509","type":"qy","chineseValue":"也门","isDel":"1","parentId":"◎3053◎3235◎","codeValue":"0.2"}],"parentIds":"","type":"","codeValue":"","englishValue":"Asia-Pacific","id":"2851","f_value":"","cc":"","types":[],"level":[],"check":"","sort":"","haveChild":"","chineseValue":"亚太","isChecked":"","parentId":"","relevance":"","beizhu_en":"","isDefault":"","pinyin":",YT,","searchName":"","f_name":"","ids":[],"isDel":"","beizhu_cn":""},{"childrenJSON":[{"englishValue":"Bermuda","pinyin":",BMD,BMD,BMD,BMD,","id":"3516","sort":"1010104","type":"qy","chineseValue":"百慕大","isDel":"1","parentId":"2003","codeValue":"0.2"},{"englishValue":"British Virgin Islands","pinyin":",YZWEJQD,YSWEJQD,","id":"3514","sort":"1010103","type":"qy","chineseValue":"英属维尔京群岛","isDel":"1","parentId":"2003","codeValue":"0.2"},{"englishValue":"Canada","pinyin":",JND,JND,","id":"2004","sort":"1010101","type":"qy","chineseValue":"加拿大","isDel":"1","parentId":"◎2003◎2070◎3401◎","codeValue":"1"},{"englishValue":"Cayman Islands","pinyin":",KMQD,","id":"3517","sort":"1010105","type":"qy","chineseValue":"开曼群岛","isDel":"1","parentId":"2003","codeValue":"0.2"},{"englishValue":"U.S.A.","pinyin":",MG,","id":"2018","sort":"1010102","type":"qy","chineseValue":"美国","isDel":"1","parentId":"◎2003◎2070◎3401◎","codeValue":"1"}],"parentIds":"","type":"","codeValue":"","englishValue":"North America","id":"2002","f_value":"","cc":"","types":[],"level":[],"check":"","sort":"","haveChild":"","chineseValue":"北美洲","isChecked":"","parentId":"","relevance":"","beizhu_en":"","isDefault":"","pinyin":",BMZ,","searchName":"","f_name":"","ids":[],"isDel":"","beizhu_cn":""},{"childrenJSON":[{"englishValue":"Albania","pinyin":",AEBNY,EEBNY,","id":"2555","sort":"1030307","type":"qy","chineseValue":"阿尔巴尼亚","isDel":"1","parentId":"2447","codeValue":"0.2"},{"englishValue":"Andorra","pinyin":",ADE,","id":"2556","sort":"1030308","type":"qy","chineseValue":"安道尔","isDel":"1","parentId":"2447","codeValue":"0.2"},{"englishValue":"Austria","pinyin":",ADL,ADL,","id":"2571","sort":"1030402","type":"qy","chineseValue":"奥地利","isDel":"1","parentId":"◎2569◎2662◎","codeValue":"0.8"},{"englishValue":"Bailiwick of Guernsey ","pinyin":",GXD,","id":"3522","sort":"1030210","type":"qy","chineseValue":"根西岛","isDel":"1","parentId":"2297","codeValue":"0.2"},{"englishValue":"Belarus","pinyin":",BELS,","id":"2576","sort":"1030501","type":"qy","chineseValue":"白俄罗斯","isDel":"1","parentId":"2575","codeValue":"0.2"},{"englishValue":"Belgium","pinyin":",BLS,","id":"2352","sort":"1030204","type":"qy","chineseValue":"比利时","isDel":"1","parentId":"◎2297◎2662◎","codeValue":"0.8"},{"englishValue":"Bosnia","pinyin":",PSNYHHSGWN,PSNYHHSGWN,PSNYHHSGWN,BSNYHHSGWN,PSNYHHSGWN,PSNYHHSGWN,BSNYHHSGWN,BSNYHHSGWN,BSNYHHSGWN,BSNYHHSGWN,PSNYHHSGWN,BSNYHHSGWN,BSNYHHSGWN,PSNYHHSGWN,BSNYHHSGWN,PSNYHHSGWN,PSNYHHSGWN,PSNYHHSGWN,BSNYHHSGWN,PSNYHHSGWN,PSNYHHSGWN,BSNYHHSGWN,BSNYHHSGWN,BSNYHHSGWN,BSNYHHSGWN,PSNYHHSGWN,PSNYHHSGWN,BSNYHHSGWN,PSNYHHSGWN,BSNYHHSGWN,PSNYHHSGWN,BSNYHHSGWN,","id":"2553","sort":"1030305","type":"qy","chineseValue":"波斯尼亚和黑塞哥维那","isDel":"1","parentId":"2447","codeValue":"0.2"},{"englishValue":"Bulgaria","pinyin":",BJLY,","id":"2563","sort":"1030315","type":"qy","chineseValue":"保加利亚","isDel":"1","parentId":"◎2447◎2662◎","codeValue":"0.2"},{"englishValue":"Channel Islands","pinyin":",HXQD,","id":"8140","type":"qy","chineseValue":"海峡群岛","isDel":"1","parentId":"2297","codeValue":"0.2"},{"englishValue":"Croatia","pinyin":",KLDY,KLDY,","id":"2557","sort":"1030309","type":"qy","chineseValue":"克罗地亚","isDel":"1","parentId":"◎2447◎2662◎","codeValue":"0.2"},{"englishValue":"Cyprus","pinyin":",SPLS,SPLS,","id":"2559","sort":"1030311","type":"qy","chineseValue":"塞浦路斯","isDel":"1","parentId":"◎2447◎3235◎2662◎","codeValue":"0.2"},{"englishValue":"Czech","pinyin":",JK,","id":"2573","sort":"1030404","type":"qy","chineseValue":"捷克","isDel":"1","parentId":"◎2569◎2662◎","codeValue":"0.5"},{"englishValue":"Denmark","pinyin":",DM,","id":"2289","sort":"1030101","type":"qy","chineseValue":"丹麦","isDel":"1","parentId":"◎2288◎2662◎","codeValue":"0.8"},{"englishValue":"Estonia","pinyin":",ASNY,","id":"2294","sort":"1030106","type":"qy","chineseValue":"爱沙尼亚","isDel":"1","parentId":"◎2288◎2662◎","codeValue":"0.2"},{"englishValue":"Faroe Islands","pinyin":",FLQD,","id":"3518","sort":"1030109","type":"qy","chineseValue":"法罗群岛","isDel":"1","parentId":"2288","codeValue":"0.2"},{"englishValue":"Finland","pinyin":",FL,","id":"2290","sort":"1030102","type":"qy","chineseValue":"芬兰","isDel":"1","parentId":"◎2288◎2662◎","codeValue":"0.8"},{"englishValue":"France","pinyin":",FG,","id":"2315","sort":"1030202","type":"qy","chineseValue":"法国","isDel":"1","parentId":"◎2297◎2662◎","codeValue":"1"},{"englishValue":"Germany","pinyin":",DG,","id":"2298","sort":"1030201","type":"qy","chineseValue":"德国","isDel":"1","parentId":"◎2297◎2662◎","codeValue":"1"},{"englishValue":"Gibraltar","pinyin":",ZBLT,","id":"3519","sort":"1030321","type":"qy","chineseValue":"直布罗陀","isDel":"1","parentId":"2447","codeValue":"0.2"},{"englishValue":"Greece","pinyin":",XX,XL,","id":"2448","sort":"1030301","type":"qy","chineseValue":"希腊","isDel":"1","parentId":"◎2447◎2662◎","codeValue":"0.5"},{"englishValue":"Hungary","pinyin":",XYL,","id":"2574","sort":"1030405","type":"qy","chineseValue":"匈牙利","isDel":"1","parentId":"◎2569◎2662◎","codeValue":"0.2"},{"englishValue":"Iceland","pinyin":",BD,","id":"2291","sort":"1030103","type":"qy","chineseValue":"冰岛","isDel":"1","parentId":"2288","codeValue":"0.2"},{"englishValue":"Ireland","pinyin":",AEL,","id":"2446","sort":"1030209","type":"qy","chineseValue":"爱尔兰","isDel":"1","parentId":"◎2297◎2662◎","codeValue":"0.2"},{"englishValue":"Italy","pinyin":",YDL,YDL,","id":"2449","sort":"1030302","type":"qy","chineseValue":"意大利","isDel":"1","parentId":"◎2447◎2662◎","codeValue":"1"},{"englishValue":"Jersey Island","pinyin":",ZXD,","id":"3523","sort":"1030211","type":"qy","chineseValue":"泽西岛","isDel":"1","parentId":"2297","codeValue":"0.2"},{"englishValue":"Latvia","pinyin":",LTWY,","id":"2295","sort":"1030107","type":"qy","chineseValue":"拉脱维亚","isDel":"1","parentId":"◎2288◎2662◎","codeValue":"0.2"},{"englishValue":"Liechtenstein","pinyin":",LZDSD,LZDSD,","id":"2351","sort":"1030203","type":"qy","chineseValue":"列支敦士登","isDel":"1","parentId":"2297","codeValue":"0.2"},{"englishValue":"Lithuania","pinyin":",LTW,LTY,LYY,LYW,","id":"2296","sort":"1030108","type":"qy","chineseValue":"立陶宛","isDel":"1","parentId":"◎2288◎2662◎","codeValue":"0.2"},{"englishValue":"Luxembourg","pinyin":",LSB,LSP,LSB,","id":"2353","sort":"1030205","type":"qy","chineseValue":"卢森堡","isDel":"1","parentId":"◎2297◎2662◎","codeValue":"0.2"},{"englishValue":"Macedonia","pinyin":",MQD,MJD,MJD,MQD,","id":"2560","sort":"1030312","type":"qy","chineseValue":"马其顿","isDel":"1","parentId":"2447","codeValue":"0.2"},{"englishValue":"Malta","pinyin":",MET,","id":"2568","sort":"1030320","type":"qy","chineseValue":"马耳他","isDel":"1","parentId":"◎2447◎2662◎","codeValue":"0.2"},{"englishValue":"Moldova","pinyin":",MEDW,MEDW,","id":"2660","sort":"1030503","type":"qy","chineseValue":"摩尔多瓦","isDel":"1","parentId":"2575","codeValue":"0.2"},{"englishValue":"Monaco","pinyin":",MNG,MNG,","id":"2567","sort":"1030319","type":"qy","chineseValue":"摩纳哥","isDel":"1","parentId":"2447","codeValue":"0.2"},{"englishValue":"Montenegro","pinyin":",HS,","id":"2561","sort":"1030313","type":"qy","chineseValue":"黑山","isDel":"1","parentId":"2447","codeValue":"0.2"},{"englishValue":"Norway","pinyin":",NW,","id":"2293","sort":"1030105","type":"qy","chineseValue":"挪威","isDel":"1","parentId":"2288","codeValue":"0.2"},{"englishValue":"Poland","pinyin":",BL,PL,","id":"2570","sort":"1030401","type":"qy","chineseValue":"波兰","isDel":"1","parentId":"◎2569◎2662◎","codeValue":"0.8"},{"englishValue":"Portugal","pinyin":",PTY,","id":"2566","sort":"1030318","type":"qy","chineseValue":"葡萄牙","isDel":"1","parentId":"◎2447◎2662◎","codeValue":"0.8"},{"englishValue":"Romania","pinyin":",LMNY,","id":"2470","sort":"1030303","type":"qy","chineseValue":"罗马尼亚","isDel":"1","parentId":"◎2447◎2662◎","codeValue":"0.5"},{"englishValue":"Russia","pinyin":",ELS,","id":"2577","sort":"1030502","type":"qy","chineseValue":"俄罗斯","isDel":"1","parentId":"2575","codeValue":"0.5"},{"englishValue":"San marino","pinyin":",SMLN,","id":"2554","sort":"1030306","type":"qy","chineseValue":"圣马力诺","isDel":"1","parentId":"2447","codeValue":"0.2"},{"englishValue":"Serbia","pinyin":",SEWY,SEWY,","id":"2562","sort":"1030314","type":"qy","chineseValue":"塞尔维亚","isDel":"1","parentId":"2447","codeValue":"0.2"},{"englishValue":"Slovak","pinyin":",SLFK,","id":"2572","sort":"1030403","type":"qy","chineseValue":"斯洛伐克","isDel":"1","parentId":"◎2569◎2662◎","codeValue":"0.2"},{"englishValue":"Slovenia","pinyin":",SLWNY,","id":"2564","sort":"1030316","type":"qy","chineseValue":"斯洛文尼亚","isDel":"1","parentId":"◎2447◎2662◎","codeValue":"0.2"},{"englishValue":"Spain","pinyin":",XBY,","id":"2558","sort":"1030310","type":"qy","chineseValue":"西班牙","isDel":"1","parentId":"◎2447◎2662◎","codeValue":"1"},{"englishValue":"Sweden","pinyin":",RD,","id":"2292","sort":"1030104","type":"qy","chineseValue":"瑞典","isDel":"1","parentId":"◎2288◎2662◎","codeValue":"0.8"},{"englishValue":"Switzerland","pinyin":",RS,","id":"2354","sort":"1030206","type":"qy","chineseValue":"瑞士","isDel":"1","parentId":"2297","codeValue":"0.8"},{"englishValue":"The Netherlands","pinyin":",HL,","id":"2355","sort":"1030207","type":"qy","chineseValue":"荷兰","isDel":"1","parentId":"◎2297◎2662◎","codeValue":"0.2"},{"englishValue":"Turkey","pinyin":",TEQ,TEJ,","id":"2471","sort":"1030304","type":"qy","chineseValue":"土耳其","isDel":"1","parentId":"◎2447◎3235◎","codeValue":"0.5"},{"englishValue":"U.K.","pinyin":",YG,","id":"2356","sort":"1030208","type":"qy","chineseValue":"英国","isDel":"1","parentId":"◎2297◎2662◎","codeValue":"1"},{"englishValue":"Ukraine","pinyin":",WKL,","id":"2661","sort":"1030504","type":"qy","chineseValue":"乌克兰","isDel":"1","parentId":"2575","codeValue":"0.2"},{"englishValue":"Vatican City State","pinyin":",FDG,","id":"2565","sort":"1030317","type":"qy","chineseValue":"梵蒂冈","isDel":"1","parentId":"2447","codeValue":"0.2"}],"parentIds":"","type":"","codeValue":"","englishValue":"Europe","id":"2287","f_value":"","cc":"","types":[],"level":[],"check":"","sort":"","haveChild":"","chineseValue":"欧洲","isChecked":"","parentId":"","relevance":"","beizhu_en":"","isDefault":"","pinyin":",OZ,","searchName":"","f_name":"","ids":[],"isDel":"","beizhu_cn":""},{"childrenJSON":[{"englishValue":"Antigua and Barbuda","pinyin":",ADGHBBD,ATGHBBD,ATGHBBD,ASGHBBD,ADGHBBD,ASGHBBD,ASGHBBD,ATGHBBD,ATGHBBD,ADGHBBD,ADGHBBD,ASGHBBD,","id":"2268","sort":"1020207","type":"qy","chineseValue":"安提瓜和巴布达","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Argentina","pinyin":",AGT,EGT,","id":"2240","sort":"1020203","type":"qy","chineseValue":"阿根廷","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Bahamas","pinyin":",BHM,BKM,","id":"2270","sort":"1020209","type":"qy","chineseValue":"巴哈马","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Barbados ","pinyin":",BBDS,","id":"2276","sort":"1020215","type":"qy","chineseValue":"巴巴多斯","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Belize","pinyin":",BLZ,BLC,BLC,BLZ,BLC,BLZ,","id":"2203","sort":"1020102","type":"qy","chineseValue":"伯利兹","isDel":"1","parentId":"2170","codeValue":"0.2"},{"englishValue":"Bolivia ","pinyin":",BLWY,","id":"2271","sort":"1020210","type":"qy","chineseValue":"玻利维亚","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Brazil","pinyin":",BX,","id":"2212","sort":"1020202","type":"qy","chineseValue":"巴西","isDel":"1","parentId":"2210","codeValue":"0.5"},{"englishValue":"Chile","pinyin":",ZL,","id":"2269","sort":"1020208","type":"qy","chineseValue":"智利","isDel":"1","parentId":"◎2210◎3401◎","codeValue":"0.2"},{"englishValue":"Columbia","pinyin":",GLBY,","id":"2283","sort":"1020222","type":"qy","chineseValue":"哥伦比亚","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Costa Rica","pinyin":",GSDLJ,","id":"2208","sort":"1020107","type":"qy","chineseValue":"哥斯达黎加","isDel":"1","parentId":"2170","codeValue":"0.2"},{"englishValue":"Cuba","pinyin":",GB,","id":"2274","sort":"1020213","type":"qy","chineseValue":"古巴","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Dominica","pinyin":",DMNJ,","id":"2278","sort":"1020217","type":"qy","chineseValue":"多米尼加","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Dominica","pinyin":",DMNK,","id":"2284","sort":"1020223","type":"qy","chineseValue":"多米尼克","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Ecuador ","pinyin":",EGDE,","id":"2272","sort":"1020211","type":"qy","chineseValue":"厄瓜多尔","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Falkland Islands","pinyin":",FKLQD,","id":"3520","sort":"1020228","type":"qy","chineseValue":"福克兰群岛","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Grenada","pinyin":",GLND,","id":"2277","sort":"1020216","type":"qy","chineseValue":"格林纳达","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Guatemala","pinyin":",WDML,WDML,","id":"2205","sort":"1020104","type":"qy","chineseValue":"危地马拉","isDel":"1","parentId":"2170","codeValue":"0.2"},{"englishValue":"Guyana","pinyin":",GYN,GYN,","id":"2281","sort":"1020220","type":"qy","chineseValue":"圭亚那","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Haiti","pinyin":",HD,HD,","id":"2280","sort":"1020219","type":"qy","chineseValue":"海地","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Honduras","pinyin":",HDLS,HDLS,","id":"2207","sort":"1020106","type":"qy","chineseValue":"洪都拉斯 ","isDel":"1","parentId":"2170","codeValue":"0.2"},{"englishValue":"Jamaica","pinyin":",YMJ,","id":"2265","sort":"1020204","type":"qy","chineseValue":"牙买加","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Mexico","pinyin":",MXG,","id":"2137","sort":"1010203","type":"qy","chineseValue":"墨西哥","isDel":"1","parentId":"◎2070◎2170◎3401◎","codeValue":"0.5"},{"englishValue":"Netherlands Antilles ","pinyin":",HZADLSQD,HZADLSQD,HSADLSQD,HSADLSQD,","id":"3513","sort":"1020226","type":"qy","chineseValue":"荷属安的列斯群岛","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Nicaragua","pinyin":",NJLG,","id":"2204","sort":"1020103","type":"qy","chineseValue":"尼加拉瓜","isDel":"1","parentId":"2170","codeValue":"0.2"},{"englishValue":"Panama","pinyin":",BNM,","id":"2206","sort":"1020105","type":"qy","chineseValue":"巴拿马","isDel":"1","parentId":"2170","codeValue":"0.2"},{"englishValue":"Paraguay","pinyin":",BLG,","id":"2282","sort":"1020221","type":"qy","chineseValue":"巴拉圭","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Peru","pinyin":",ML,BL,LL,","id":"2286","sort":"1020225","type":"qy","chineseValue":"秘鲁","isDel":"1","parentId":"◎2210◎3401◎","codeValue":"0.2"},{"englishValue":"Saint Kitts and Nevis","pinyin":",SJCHNWS,SJCHNWS,SJCHNWS,SJCHNWS,","id":"2273","sort":"1020212","type":"qy","chineseValue":"圣基茨和尼维斯","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Saint Lucia","pinyin":",SLXY,","id":"2267","sort":"1020206","type":"qy","chineseValue":"圣卢西亚","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Saint Vincent and the Grenadines","pinyin":",SWSTHGLNZS,SWSTHGLNDS,SWSTHGLNDS,SWSTHGLNZS,SWSTHGLNDS,SWSTHGLNZS,SWSTHGLNZS,SWSTHGLNDS,","id":"2285","sort":"1020224","type":"qy","chineseValue":"圣文森特和格林纳丁斯","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Salvador","pinyin":",SEWD,","id":"2209","sort":"1020108","type":"qy","chineseValue":"萨尔瓦多","isDel":"1","parentId":"2170","codeValue":"0.2"},{"englishValue":"Surinam","pinyin":",SLN,SLN,","id":"2266","sort":"1020205","type":"qy","chineseValue":"苏里南","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Trinidad and Tobago","pinyin":",TLNDHDBG,TLNDHDBG,TLNDHDBG,TLNDHDBG,","id":"2279","sort":"1020218","type":"qy","chineseValue":"特立尼达和多巴哥","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"United States Virgin Islands","pinyin":",MSWEJQD,MZWEJQD,","id":"3515","sort":"1020227","type":"qy","chineseValue":"美属维尔京群岛","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Uruguay","pinyin":",WLG,","id":"2275","sort":"1020214","type":"qy","chineseValue":"乌拉圭","isDel":"1","parentId":"2210","codeValue":"0.2"},{"englishValue":"Venezuela","pinyin":",WNRL,","id":"2211","sort":"1020201","type":"qy","chineseValue":"委内瑞拉","isDel":"1","parentId":"2210","codeValue":"0.2"}],"parentIds":"","type":"","codeValue":"","englishValue":"Latin America","id":"2169","f_value":"","cc":"","types":[],"level":[],"check":"","sort":"","haveChild":"","chineseValue":"拉丁美洲","isChecked":"","parentId":"","relevance":"","beizhu_en":"","isDefault":"","pinyin":",LDMZ,LZMZ,","searchName":"","f_name":"","ids":[],"isDel":"","beizhu_cn":""},{"childrenJSON":[{"englishValue":"Abuja","pinyin":",ABJ,","id":"17090","sort":"1050318","type":"qy","chineseValue":"阿布贾","isDel":"1","parentId":"3165","codeValue":"0.2"},{"englishValue":"Algeria","pinyin":",AEJLY,EEJLY,","id":"3154","sort":"1050106","type":"qy","chineseValue":"阿尔及利亚","isDel":"1","parentId":"3148","codeValue":"0.2"},{"englishValue":"Angola","pinyin":",AGL,","id":"3195","sort":"1050501","type":"qy","chineseValue":"安哥拉","isDel":"1","parentId":"3194","codeValue":"0.2"},{"englishValue":"Bahrain","pinyin":",BL,","id":"3057","sort":"1040504","type":"qy","chineseValue":"巴林","isDel":"1","parentId":"◎3053◎3215◎3235◎","codeValue":"0.2"},{"englishValue":"Benin","pinyin":",BN,","id":"3179","sort":"1050314","type":"qy","chineseValue":"贝宁","isDel":"1","parentId":"3165","codeValue":"0.2"},{"englishValue":"Botswana","pinyin":",BCWN,","id":"3196","sort":"1050502","type":"qy","chineseValue":"博茨瓦纳","isDel":"1","parentId":"3194","codeValue":"0.2"},{"englishValue":"Burkina Faso","pinyin":",BJNFS,","id":"3171","sort":"1050306","type":"qy","chineseValue":"布基纳法索","isDel":"1","parentId":"3165","codeValue":"0.2"},{"englishValue":"Burundi","pinyin":",BLD,","id":"3192","sort":"1050409","type":"qy","chineseValue":"布隆迪","isDel":"1","parentId":"3183","codeValue":"0.2"},{"englishValue":"Cameroon","pinyin":",KML,KML,","id":"3159","sort":"1050203","type":"qy","chineseValue":"喀麦隆","isDel":"1","parentId":"3156","codeValue":"0.2"},{"englishValue":"Central Africa","pinyin":",ZF,","id":"3158","sort":"1050202","type":"qy","chineseValue":"中非","isDel":"1","parentId":"3156","codeValue":"0.2"},{"englishValue":"Chad","pinyin":",ZD,ZD,","id":"3157","sort":"1050201","type":"qy","chineseValue":"乍得","isDel":"1","parentId":"3156","codeValue":"0.2"},{"englishValue":"Comoros","pinyin":",KML,KML,","id":"3198","sort":"1050504","type":"qy","chineseValue":"科摩罗","isDel":"1","parentId":"3194","codeValue":"0.2"},{"englishValue":"Congo","pinyin":",GGB,","id":"3161","sort":"1050205","type":"qy","chineseValue":"刚果（布）","isDel":"1","parentId":"3156","codeValue":"0.2"},{"englishValue":"Congo Kinshasa","pinyin":",GGJ,","id":"3162","sort":"1050206","type":"qy","chineseValue":"刚果（金）","isDel":"1","parentId":"3156","codeValue":"0.2"},{"englishValue":"Cyprus","pinyin":",SPLS,SPLS,","id":"2559","sort":"1030311","type":"qy","chineseValue":"塞浦路斯","isDel":"1","parentId":"◎2447◎3235◎2662◎","codeValue":"0.2"},{"englishValue":"Djibouti","pinyin":",JBT,JBS,JBD,","id":"3187","sort":"1050404","type":"qy","chineseValue":"吉布提","isDel":"1","parentId":"3183","codeValue":"0.2"},{"englishValue":"Egypt","pinyin":",AJ,","id":"3149","sort":"1050101","type":"qy","chineseValue":"埃及","isDel":"1","parentId":"◎3148◎3235◎","codeValue":"0.2"},{"englishValue":"Equatorial Guinea","pinyin":",CDJNY,","id":"3160","sort":"1050204","type":"qy","chineseValue":"赤道几内亚","isDel":"1","parentId":"3156","codeValue":"0.2"},{"englishValue":"Eritrea","pinyin":",ELTLY,","id":"3185","sort":"1050402","type":"qy","chineseValue":"厄立特里亚","isDel":"1","parentId":"3183","codeValue":"0.2"},{"englishValue":"Ethiopia","pinyin":",ASEBY,ASEBY,","id":"3184","sort":"1050401","type":"qy","chineseValue":"埃塞俄比亚","isDel":"1","parentId":"3183","codeValue":"0.2"},{"englishValue":"Gabon","pinyin":",JP,","id":"3163","sort":"1050207","type":"qy","chineseValue":"加蓬","isDel":"1","parentId":"3156","codeValue":"0.2"},{"englishValue":"Gambia","pinyin":",GBY,","id":"3169","sort":"1050304","type":"qy","chineseValue":"冈比亚","isDel":"1","parentId":"3165","codeValue":"0.2"},{"englishValue":"Ghana","pinyin":",JN,","id":"3178","sort":"1050313","type":"qy","chineseValue":"加纳","isDel":"1","parentId":"3165","codeValue":"0.2"},{"englishValue":"Guinea","pinyin":",JNY,","id":"3172","sort":"1050307","type":"qy","chineseValue":"几内亚","isDel":"1","parentId":"3165","codeValue":"0.2"},{"englishValue":"Guinea Bissau","pinyin":",JNYBS,","id":"3173","sort":"1050308","type":"qy","chineseValue":"几内亚比绍","isDel":"1","parentId":"3165","codeValue":"0.2"},{"englishValue":"Iran","pinyin":",YL,","id":"3076","sort":"1040510","type":"qy","chineseValue":"伊朗","isDel":"1","parentId":"◎3053◎3235◎","codeValue":"0.2"},{"englishValue":"Iraq","pinyin":",YLK,","id":"3077","sort":"1040511","type":"qy","chineseValue":"伊拉克","isDel":"1","parentId":"◎3053◎3235◎","codeValue":"0.2"},{"englishValue":"Israel","pinyin":",YSL,YSL,","id":"3078","sort":"1040512","type":"qy","chineseValue":"以色列","isDel":"1","parentId":"◎3053◎3235◎","codeValue":"1"},{"englishValue":"Ivory Coast","pinyin":",KTDW,","id":"3177","sort":"1050312","type":"qy","chineseValue":"科特迪瓦","isDel":"1","parentId":"3165","codeValue":"0.2"},{"englishValue":"Jordan","pinyin":",YD,YD,","id":"3079","sort":"1040513","type":"qy","chineseValue":"约旦","isDel":"1","parentId":"◎3053◎3235◎","codeValue":"0.2"},{"englishValue":"Kenya","pinyin":",KNY,","id":"3188","sort":"1050405","type":"qy","chineseValue":"肯尼亚","isDel":"1","parentId":"3183","codeValue":"0.2"},{"englishValue":"Kuwait","pinyin":",KWT,","id":"3059","sort":"1040506","type":"qy","chineseValue":"科威特","isDel":"1","parentId":"◎3053◎3215◎3235◎","codeValue":"0.2"},{"englishValue":"Lebanon","pinyin":",LBN,","id":"3060","sort":"1040507","type":"qy","chineseValue":"黎巴嫩","isDel":"1","parentId":"◎3053◎3235◎","codeValue":"0.2"},{"englishValue":"Lesotho","pinyin":",LST,","id":"3199","sort":"1050505","type":"qy","chineseValue":"莱索托","isDel":"1","parentId":"3194","codeValue":"0.2"},{"englishValue":"Liberia","pinyin":",LBLY,","id":"3176","sort":"1050311","type":"qy","chineseValue":"利比里亚","isDel":"1","parentId":"3165","codeValue":"0.2"},{"englishValue":"Libya","pinyin":",LBY,","id":"3152","sort":"1050104","type":"qy","chineseValue":"利比亚","isDel":"1","parentId":"3148","codeValue":"0.2"},{"englishValue":"Madagascar","pinyin":",MDJSJ,","id":"3200","sort":"1050506","type":"qy","chineseValue":"马达加斯加","isDel":"1","parentId":"3194","codeValue":"0.2"},{"englishValue":"Malawi","pinyin":",MLW,","id":"3526","sort":"1050512","type":"qy","chineseValue":"马拉维","isDel":"1","parentId":"3194","codeValue":"0.2"},{"englishValue":"Mali","pinyin":",ML,","id":"3170","sort":"1050305","type":"qy","chineseValue":"马里","isDel":"1","parentId":"3165","codeValue":"0.2"},{"englishValue":"Mauritania","pinyin":",MLDNY,MLTNY,","id":"3166","sort":"1050301","type":"qy","chineseValue":"毛里塔尼亚","isDel":"1","parentId":"3165","codeValue":"0.2"},{"englishValue":"Mauritius","pinyin":",MLQS,","id":"3201","sort":"1050507","type":"qy","chineseValue":"毛里求斯","isDel":"1","parentId":"3194","codeValue":"0.2"},{"englishValue":"Morocco","pinyin":",MLG,MLG,","id":"3155","sort":"1050107","type":"qy","chineseValue":"摩洛哥","isDel":"1","parentId":"3148","codeValue":"0.2"},{"englishValue":"Mozambique","pinyin":",MSBK,","id":"3202","sort":"1050508","type":"qy","chineseValue":"莫桑比克","isDel":"1","parentId":"3194","codeValue":"0.2"},{"englishValue":"Namibia","pinyin":",NMBY,","id":"3203","sort":"1050509","type":"qy","chineseValue":"纳米比亚","isDel":"1","parentId":"3194","codeValue":"0.2"},{"englishValue":"Niger","pinyin":",NRE,","id":"3181","sort":"1050316","type":"qy","chineseValue":"尼日尔","isDel":"1","parentId":"3165","codeValue":"0.2"},{"englishValue":"Nigeria","pinyin":",NRLY,","id":"3182","sort":"1050317","type":"qy","chineseValue":"尼日利亚","isDel":"1","parentId":"3165","codeValue":"0.2"},{"englishValue":"Oman","pinyin":",AM,EM,","id":"3055","sort":"1040502","type":"qy","chineseValue":"阿曼","isDel":"1","parentId":"◎3053◎3215◎3235◎","codeValue":"0.2"},{"englishValue":"Palestine","pinyin":",BLST,BLST,","id":"3056","sort":"1040503","type":"qy","chineseValue":"巴勒斯坦","isDel":"1","parentId":"◎3053◎3235◎","codeValue":"0.2"},{"englishValue":"Qatar","pinyin":",QDE,QTE,KDE,KTE,","id":"3058","sort":"1040505","type":"qy","chineseValue":"卡塔尔","isDel":"1","parentId":"◎3053◎3215◎3235◎","codeValue":"0.2"},{"englishValue":"Rwanda","pinyin":",LWD,","id":"3191","sort":"1050408","type":"qy","chineseValue":"卢旺达","isDel":"1","parentId":"3183","codeValue":"0.2"},{"englishValue":"Sao Tome Principe","pinyin":",SDMHPLXB,SDMHPLXB,SDMHPLXB,SDMHPLXB,","id":"3164","sort":"1050208","type":"qy","chineseValue":"圣多美和普林西比","isDel":"1","parentId":"3156","codeValue":"0.2"},{"englishValue":"Senegal","pinyin":",SNJE,SNJE,","id":"3168","sort":"1050303","type":"qy","chineseValue":"塞内加尔","isDel":"1","parentId":"3165","codeValue":"0.2"},{"englishValue":"Seychelles","pinyin":",SSE,SSE,","id":"3193","sort":"1050410","type":"qy","chineseValue":"塞舌尔","isDel":"1","parentId":"3183","codeValue":"0.2"},{"englishValue":"Sierra Leone","pinyin":",SLLA,SLLA,","id":"3175","sort":"1050310","type":"qy","chineseValue":"塞拉利昂","isDel":"1","parentId":"3165","codeValue":"0.2"},{"englishValue":"Somali","pinyin":",SML,","id":"3186","sort":"1050403","type":"qy","chineseValue":"索马里","isDel":"1","parentId":"3183","codeValue":"0.2"},{"englishValue":"South Africa","pinyin":",NF,NF,","id":"3204","sort":"1050510","type":"qy","chineseValue":"南非","isDel":"1","parentId":"3194","codeValue":"0.5"},{"englishValue":"South Sudan","pinyin":",NSD,NSD,","id":"3151","sort":"1050103","type":"qy","chineseValue":"南苏丹","isDel":"1","parentId":"3148","codeValue":"0.2"},{"englishValue":"Sudan","pinyin":",SD,","id":"3150","sort":"1050102","type":"qy","chineseValue":"苏丹","isDel":"1","parentId":"3148","codeValue":"0.2"},{"englishValue":"Syria","pinyin":",XLY,","id":"3080","sort":"1040514","type":"qy","chineseValue":"叙利亚","isDel":"1","parentId":"◎3053◎3235◎","codeValue":"0.2"},{"englishValue":"Tanzania","pinyin":",TSNY,","id":"3189","sort":"1050406","type":"qy","chineseValue":"坦桑尼亚","isDel":"1","parentId":"3183","codeValue":"0.2"},{"englishValue":"The Kingdom of Swaziland","pinyin":",swsl,","id":"41320","sort":"1050513","type":"qy","chineseValue":"斯威士兰","isDel":"1","parentId":"3194","codeValue":"0.2"},{"englishValue":"Togo","pinyin":",DG,","id":"3180","sort":"1050315","type":"qy","chineseValue":"多哥","isDel":"1","parentId":"3165","codeValue":"0.2"},{"englishValue":"Tunisia","pinyin":",TNS,","id":"3153","sort":"1050105","type":"qy","chineseValue":"突尼斯","isDel":"1","parentId":"3148","codeValue":"0.2"},{"englishValue":"Turkey","pinyin":",TEQ,TEJ,","id":"2471","sort":"1030304","type":"qy","chineseValue":"土耳其","isDel":"1","parentId":"◎2447◎3235◎","codeValue":"0.5"},{"englishValue":"Uganda","pinyin":",WGD,","id":"3190","sort":"1050407","type":"qy","chineseValue":"乌干达","isDel":"1","parentId":"3183","codeValue":"0.2"},{"englishValue":"United Arab Emirates","pinyin":",ALBLGQCG,ELBLHQZG,ELBLHQCG,ELBLHQZG,ALBLHQZG,ELBLGQCG,ALBLHQCG,ALBLGQZG,ALBLHQCG,ELBLGQZG,ALBLHQZG,ALBLGQCG,ELBLGQCG,ALBLHQCG,ALBLGQZG,ELBLHQCG,ELBLGQZG,ELBLGQZG,ELBLHQZG,ELBLHQCG,ALBLGQCG,ALBLHQZG,ELBLGQCG,ALBLGQZG,","id":"3054","sort":"1040501","type":"qy","chineseValue":"阿拉伯联合酋长国","isDel":"1","parentId":"◎3053◎3215◎3235◎","codeValue":"0.2"},{"englishValue":"Verde","pinyin":",FDJ,FDJ,FDJ,FDJ,FDJ,FDJ,FDJ,FDJ,FDJ,FDJ,FDJ,FDJ,","id":"3174","sort":"1050309","type":"qy","chineseValue":"佛得角","isDel":"1","parentId":"3165","codeValue":"0.2"},{"englishValue":"Western Sahara","pinyin":",XSHL,XSKL,","id":"3167","sort":"1050302","type":"qy","chineseValue":"西撒哈拉","isDel":"1","parentId":"3165","codeValue":"0.2"},{"englishValue":"Yemen","pinyin":",YM,","id":"3075","sort":"1040509","type":"qy","chineseValue":"也门","isDel":"1","parentId":"◎3053◎3235◎","codeValue":"0.2"},{"englishValue":"Zambia","pinyin":",ZBY,","id":"3214","sort":"1050511","type":"qy","chineseValue":"赞比亚","isDel":"1","parentId":"3194","codeValue":"0.2"},{"englishValue":"Zimbabwe","pinyin":",JBBW,","id":"3197","sort":"1050503","type":"qy","chineseValue":"津巴布韦","isDel":"1","parentId":"3194","codeValue":"0.2"}],"parentIds":"","type":"","codeValue":"","englishValue":"Africa & Middle East","id":"3147","f_value":"","cc":"","types":[],"level":[],"check":"","sort":"","haveChild":"","chineseValue":"非洲中东","isChecked":"","parentId":"","relevance":"","beizhu_en":"","isDefault":"","pinyin":",FZZD,","searchName":"","f_name":"","ids":[],"isDel":"","beizhu_cn":""}];
export const priceRange = [{"titleTocn":"100万以下","titleTous":"Up to 1 million","id":"15040","max":1000000},{"titleTocn":"100万~300万(含)","titleTous":"1-3 million","id":"15041","min":1000000,"max":3000000},{"titleTocn":"300万~500万(含)","titleTous":"3-5 million","id":"16094","min":3000000,"max":5000000},{"titleTocn":"500万~1000万(含)","titleTous":"5-10 million","id":"16095","min":5000000,"max":10000000},{"titleTocn":"1000万~3000万(含)","titleTous":"10-30 million","id":"16096","min":10000000,"max":30000000},{"titleTocn":"3000万~5000万(含)","titleTous":"30-50 million","id":"16097","min":30000000,"max":50000000},{"titleTocn":"5000万~8000万(含)","titleTous":"50-80 million","id":"16098","min":50000000,"max":80000000},{"titleTocn":"8000万~1亿(含)","titleTous":"80-100 million","id":"16099","min":80000000,"max":100000000},{"titleTocn":"1亿~5亿(含)","titleTous":"100-500 million","id":"16100","min":100000000,"max":500000000},{"titleTocn":"5亿~10亿(含)","titleTous":"500 million-1 billion","id":"16101","min":500000000,"max":1000000000},{"titleTocn":"10亿以上","titleTous":"More than 1 billion","id":"16102","min":1000000000}];

export const thisUrl = process.env.VUE_APP_THIS_URL
export const menuData = [
  {
    name: '首页',
    nameEn: 'Homepage',
    url: '/',
  },
  {
    name: '对外投资',
    nameEn: 'Oversea Investment',
    children:[
      {
        name: 'ODI申请流程',
        nameEn: 'ODI Application Process',
        url: '/odi',
      },
      {
        name: '商务委备案所需材料',
        nameEn: 'Filings For MOFCOM',
        url: '/commerce',
      },
      {
        name: '发改委备案所需材料',
        nameEn: 'Filings For NDRC',
        url: '/devAndReform',
      },
      {
        name: '常见问题Q&A',
        nameEn: 'Q&A',
        url: '/qa',
      },
    ]
  },
  {
    name: '项目库',
    nameEn: 'Project',
    url: '/welcome',
  },
  {
    name: '专业服务',
    nameEn: 'Professional Service',
    children:[]
  },
  {
    name: '金融服务',
    nameEn: 'Financial Service',
    children:[]
  },
  {
    name: '人才服务',
    nameEn: 'Talent Service',
    children:[
      {
        name: '外国人服务中心',
        nameEn: 'Foreigner Service Center',
        url: '/foreigner'
      },
      {
        name: '人才库',
        nameEn: 'Talent Database',
      },
    ]
  },
  {
    name: '活动',
    nameEn: 'Activity',
    url: '/activity/list',
  },
  {
    name: '资讯',
    nameEn: 'Intelligence',
    children:[]
  },
  {
    name: '国别/地区投资指南',
    nameEn: 'Investment Guidance(Countries and Regions)',
    url: '/area/list'
  },
]

const proMenu = menuData[3]
for (const key in scheduleTypes.professional) {
  const pro = scheduleTypes.professional[key]
  proMenu.children.push({
    name: pro.name,
    nameEn: pro.nameEn,
    url: "/schedule/1/" + pro.type
  })
}
const finMenu = menuData[4]
for (const key in scheduleTypes.financial) {
  const fin = scheduleTypes.financial[key]
  finMenu.children.push({
    name: fin.name,
    nameEn: fin.nameEn,
    url: "/schedule/2/" + fin.type
  })
}
const newsMenu = menuData[7]
for (const key in newsCategoryIdArray) {
  const fin = newsCategoryIdArray[key]
  newsMenu.children.push({
    name: newsCategoryIdToName[fin],
    nameEn: newsCategoryIdToNameEn[fin],
    url: "/news/list/" + fin
  })
}
export const cookieKey = "MW_JWT_COOKIE";
export const deviceIdKey = "MW_JWT_DEVICE_ID";
export const imageServerUrl = process.env.VUE_APP_IMAGE_SERVER_URL
export const webServer = process.env.VUE_APP_SERVER_URL
export const accountWebServer = process.env.VUE_APP_ACCOUNT_WEB_SERVER_URL
export const thisImageServer = process.env.VUE_APP_THIS_IMAGE_SERVER_URL
export const loginPath = accountWebServer + "/website/register!checkLogin.action?&language=zh_CN&request_locale=zh_CN&&platformChannel=fAKr2MSTorVXJXRn&go_back="
export const registerPath = accountWebServer + "/website/register!toRegister.action?&language=zh_CN&request_locale=zh_CN&&platformChannel=fAKr2MSTorVXJXRn&go_back="



